const brand = sessionStorage.getItem('brand');
export const botBuilder = {
  canvas: {
    chatflowBuilderLoading: 'Chatflow Builder 正在加载...',
    slowNetworkDetected: '检测到网络缓慢',
    editYourChatFlow: '编辑您的聊天流程',
    seeHowToUse: '查看如何使用',
    help: '帮助',
    classicBuilder: '经典构建器',
    visualiseFlow: '可视化流程',
    testLiveOnTelegramWeb: '在 Telegram Web 上测试实时',
    testFlow: '测试流程',
    importTemplate: '导入模板',
    landingPageBotReview: '落地页机器人预览',
    install: '安装',
    testLiveOnMessengerWeb: '在 Messenger Web 上测试实时',
    testLiveOnWhatsappWeb: '在 WhatsApp Web 上测试实时',
    testLiveOnInstagramWeb: '在 Instagram Web 上测试实时',
    seeAllChatFlow: '查看所有聊天流程',
    launchDemoModal: '启动演示模态框',
    selectATemplateToKickStartYourBot: '选择一个模板来启动您的机器人',
    hireChatBotDesigner: '聘请聊天机器人设计师',
    recommendedForYou: '为您推荐',
    useTemplate: '使用模板',
    exportStatus: '导出状态',
    flowExport: '流程导出',
    download: '下载',
    importFlow: '导入流程',
    beforeYouStartUploadPleaseMakeSure: '在开始上传之前，请确保',
    point1: '1. 文件最大上传限制为 20MB',
    point2: '2. 文件格式应为 JSON',
    selectFile: '选择文件',
    preview: '预览',
    test: '测试',
    OopsIntegrationAreNotAvailable: '糟糕！在此处集成不可用 ',
    pleaseUpgradeTo: ' 请升级到 ',
    planForIntegration: ' 以进行集成。',
    areYouSure: '您确定吗？',
    yesUseTemplate: '是的，使用模板！',
    importTemplateDescription: '导入此模板将替换现有的聊天流程。任何未保存的更改将丢失。',
    placeholders: {
      searchTemplateYouNeed: '搜索您需要的模板',
    },
    noDataFound: {
      botFlow: '机器人流程',
      noBotFlowAddedYet: '尚未添加机器人流程！',
      templates: '模板',
      noTemplatesFound: '未找到模板！',
    },
    appTooltip: {
      exportFlow: '导出流程',
      importFlow: '导入流程',
      clickToViewChatFlow: '单击以在拖放构建器中查看聊天流程',
      clickToPreviewChatFlow: '单击以预览聊天流程',
      clickToViewChatFlowAsFlowDiagram: '单击以将聊天流程显示为流程图',
      clickToTestChatFlow: '单击以测试聊天流程',
      clickToSelectAndImportTemplate: '单击以选择并导入最适合您业务的模板。',
      clickToInstallYourBotToSelectedPlatform: '单击以将您的机器人安装到所选平台',
      clickToTestDefaultFlowOfTelegramBot: `单击以在 Telegram Web 上测试您机器人的默认（活动）流程`,
      clickToTestDefaultFlowOfFacebookBot: `单击以在 Facebook Web 上测试您机器人的默认（活动）流程`,
      clickToTestDefaultFlowOfWhatsappBot: `单击以在 WhatsApp Web 上测试您机器人的默认（活动）流程`,
      clickToTestDefaultFlowOfInstagramBot: `单击以在 Instagram Web 上测试您机器人的默认（活动）流程`,
    }
  },
  createNewBot: {
    createNewBot: '创建新的机器人',
    stepOneOfTwo: '第1步/2步',
    selectThePlatform: '选择平台',
    selectTheBotType: '选择机器人类型',
    aiBasedChatbot: '基于AI的聊天机器人',
    ruleBasedChatBot: '基于规则的聊天机器人',
    webPlatforms: 'Web平台',
    websiteChatBot: '网站聊天机器人',
    withLiveChat: '(带有实时聊天)',
    landingPageBot: '着陆页机器人',
    liveChatWidget: '实时聊天小部件',
    onlyLiveChat: '(仅实时聊天)',
    socialPlatforms: '社交平台',
    whatsappChatBot: 'WhatsApp聊天机器人',
    telegramChatBot: 'Telegram聊天机器人',
    facebookChatBot: 'Facebook聊天机器人',
    instagramChatBot: 'Instagram聊天机器人',
    selectBotType: '选择机器人类型',
    selectProblem: '选择您想解决的问题',
    leadGeneration: '潜在客户生成',
    customerSupport: '客户支持',
    appointmentBooking: '预约预订',
    marketingAutomation: '营销自动化',
    ecommerceWebsite: '电子商务网站',
    otherUseCase: '其他',
    back: '返回',
    typeDomainUrl: '键入您的网站URL以进行验证。',
    dataSourceForChatBotTraining: '聊天机器人培训的数据源',
    upload: '上传',
    uploadDocuments: '上传文件',
    uploadDocument: '上传文档',
    selectFile: '选择文件',
    continue: '继续',
    websiteUrl: '键入您的网站URL',
    skipNow: '现在跳过',
    completeTheExistingBotSetup: '完成现有的机器人设置',
    youHaveAlreadyCreatedOneWhatsAppBot: '您已经创建了一个WhatsApp机器人，请完成相同机器人的设置以创建一个新的机器人。',
    completeSetup: '完成设置',
    seeHowToUse: '查看如何使用',
    help: '帮助',
    fbBot: {
      createNewBot: '创建新的机器人',
      help: '帮助',
      back: '返回',
      step: '步骤 ',
      of3: ' / 3',
      loginWithFacebook: '使用Facebook登录',
      asPerLatestChangesInFacebookPolicy: '根据Facebook政策的最新更改，Facebook机器人所有者必须具有`经理`或更高角色才能访问所有Facebook页面的功能。',
      login: '登录',
      connectFacebookBot: '连接Facebook机器人',
      connectBotWithYourFacebookPagesAnd: '将机器人连接到您的Facebook页面，并',
      exploreTruePowerOfFacebook: '探索Facebook的真正力量',
      connect: '连接',
      connected: '已连接',
      createNewPage: '创建新页面',
      refreshPageList: '刷新页面列表',
      thisPageIsSuccessfullyIntegratedWith: '此页面已成功与',
      yourMessagesFromMessengerWillAppearIn: '集成。您的Messenger消息将显示在',
      inbox: '收件箱',
      continueToBotConfiguration: '继续进行机器人配置',
      welcomeToBrandNameWeAreHereToHelpYou: `欢迎来到${brand}！我们在这里帮助您。`,
      letsTryYourBotAndSeeHowItWorks: `让我们尝试您的机器人并看看它是如何工作的！点击“在Facebook上测试”。`,
      howAreYouDoingToday: '你今天过得如何？',
      thisIsHowSimpleToUseFacebookBot: `就是这样！使用Facebook机器人是多么简单`,
      letsCreateYourOwnChatFlowNow: `现在让我们创建您自己的聊天流程`,
    },
    instagramBot: {
      createNewBot: '创建新机器人',
      back: '返回',
      step: '步骤 ',
      of3: ' 的 3',
      loginWithInstagram: '使用 Instagram 登录',
      loginToYourInstagramAccount: '登录到您的 Instagram 帐户以启用聊天机器人。',
      managerLevelDescription: 'Instagram 机器人所有者需要至少具有 "管理者" 等级或更高权限才能访问所有功能。',
      login: '登录',
      connectInstagramBot: '连接 Instagram 机器人',
      connectBotWithYourInstagramAnd: '将机器人与您的 Instagram 连接并',
      exploreTruePowerOfInstagram: ' 发掘 Instagram 的真正力量',
      connected: '已连接',
      connect: '连接',
      createNewPage: '创建新页面',
      refreshPageList: '刷新页面列表',
      thisPageIsSuccessfullyintegratedWith: '此页面已成功集成到 ',
      yourMessagesFromMessengerWillAppearIn: '。您的 Messenger 消息将出现在 ',
      inbox: ' 收件箱',
      continueToBotConfiguration: '继续到机器人配置',
      welcomeToBrandNameWeAreHereToHelpYou: `欢迎来到 ${brand}。我们在这里帮助您。`,
      letsTryYourBotAndSeeHowItWorks: `让我们尝试您的机器人并看看它如何工作！点击“在 Instagram 上测试”。`,
      howAreYouDoingToday: '今天您过得如何？',
      thisIsHowSimpleToUseInstagramBot: `就是这样！使用 Instagram 机器人是多么简单`,
      letsCreateYourOwnChatFlowNow: `现在让我们创建您自己的聊天流程`,
    },
    telegramBot: {
      back: '返回',
      step: '步骤 ',
      of3: ' 的 3',
      seeHowToUse: '查看如何使用',
      help: '帮助',
      loginToYourTelegramAccount: '登录到您的 Telegram 帐户',
      loginToYourAccountToCreateNewBotOrConnectExistingBot: '登录到您的帐户以创建新机器人或连接现有机器人',
      verificationCodeSentOnRegisteredNumber: '验证码发送到注册的号码',
      createYourBot: '创建您的机器人',
      enterYourBotsNameAnd: '输入您的机器人名称，并连接开始',
      botUserNameMustEndWithBotAtTheEnd: '机器人用户名必须以 "bot" 结尾。',
      terrisBot: '例如 terris_bot 或 terrisbot',
      botNameAlreadyTaken: '此机器人名称已被占用。请尝试其他名称',
      connect: '连接',
      createBot: '创建机器人',
      codeNotReceivedResend: '未收到代码？重新发送！',
      changeNumber: '更改号码',
      telegramPreview: 'Telegram 预览',
      worldsFastestMessagingApp: '全球最快的消息应用，而且是免费的！',
      bot: '机器人',
      phoneNumber: '手机号码',
      userName: '用户名',
      none: '无',
      bio: '个人简介',
      fewWordsAboutYourself: '简短介绍自己',
      settings: '设置',
      notificationsAndSound: '通知和声音',
      privacyAndSecurity: '隐私和安全',
      dataAndStorage: '数据和存储',
      chatSettings: '聊天设置',
      chatFolders: '聊天文件夹',
      devices: '设备',
      connectYourBot: '连接您的机器人',
      createNewBotOrConnectWithExistingOne: '创建新机器人或连接现有机器人',
      createNewBot: '创建新机器人',
      welcomeToBrandNameWeAreHereToHelpYou: `欢迎来到 ${brand}。我们在这里帮助您。`,
      letsTryYourBotAndSeeHowItWorks: `让我们尝试您的机器人并看看它如何工作！点击“在 Telegram 上测试”。`,
      howAreYouDoingToday: '今天您过得如何？',
      thisIsHowSimpleToUseTelegramBot: `就是这样！使用 Telegram 机器人是多么简单`,
      letsCreateYourOwnChatFlowNow: `现在让我们创建您自己的聊天流程`,
      placeholders: {
        searchCountry: '搜索国家',
        enterTelegramMobileNumber: '输入 Telegram 手机号码',
        enterLoginCodeReceived: '输入在 Telegram 帐户上收到的登录代码 *',
        twoFactorAuthentication: '两步验证密码（可选）',
        botName: '机器人名称 *',
        botUserName: '机器人用户名 *',
      }
    },
    websiteLandingPageLiveChatBot: {
      createNewBot: '创建新机器人',
      seeHowToUse: '查看如何使用',
      help: '帮助',
      back: '返回',
      step: '步骤 ',
      of2: ' / 2',
      buildA: '创建一个',
      thatMatchesYourBrandPersonality: '符合您品牌个性的',
      chatBotIcon: '聊天机器人图标 ',
      optional: '可选',
      themeColor: '主题颜色',
      chatBotName: '聊天机器人名称',
      botNameIsRequired: '聊天机器人名称是必填项',
      botNameShouldBeLessThan50Characters: '聊天机器人名称应少于50个字符',
      continue: '继续',
      welcomeToBrandNameWeAreHereToHelpYou: `欢迎来到${brand}。我们在这里帮助您。`,
      whatIsYourEmailAddress: '您的电子邮件地址是什么？',
      invalidEmailAddress: '无效的电子邮件地址',
      customizeYourLandingPageBotLook: '定制您的着陆页机器人外观',
      customizeYourWidgetLook: '定制您的小部件外观',
      customizeYourBotLook: '定制您的机器人外观',
      buildYourLandingPageBotAndAutomateInteraction: '构建您的着陆页机器人并通过分享其链接自动与客户互动',
      useLiveChatBotToConnectToCustomers: '使用实时聊天机器人与客户实时连接',
      connectChatBotToYourWebsiteAndAutomateInteractions: '将聊天机器人连接到您的网站并自动与访客互动',
      widget: '小部件',
      botInterface: '机器人界面',
      mergedBot: '网站聊天机器人、着陆页机器人、移动应用聊天机器人',
      mergedBotToolTip: '创建一个机器人页面，以吸引访客的注意并在对话中与他们互动。',
      placeholders: {
        typeANameForYourBot: '为您的新机器人键入名称',
      },
      appTooltip: {
        TOOLTIP_WEBSITE_BOT_NAME: '输入您的机器人名称',
        mergedBotToolTip: '创建一个机器人页面，以吸引访客的注意并在对话中与他们互动。',
        TOOLTIP_WEBSITE_BOT_THEME_COLOR: '为您的聊天窗口选择一个主题颜色',
        thisLogoWillBeUsedInTheBrandNamePlatformOnly: `此标志仅在${brand ? brand : ''}平台上使用。我们建议选择公司标志。请添加一个大小不超过1 MB的PNG或JPG方形图像。`
      }
    },
    whatsappBot: {
      back: '返回',
      justAStepAway: '只差一步',
      seeHowToUse: '查看如何使用',
      help: '帮助',
      createWhatsappChatBot: '创建聊天机器人',
      businessNameIsRequired: '必须提供业务名称。',
      maximumLengthForBusinessName40Characters: '业务名称的最大长度为40个字符。',
      businessCategory: '业务类别',
      categoryIsRequired: '类别为必填项。',
      descriptionIsRequired: '描述为必填项。',
      maximumLengthForDescription200Characters: '描述的最大长度为200个字符。',
      pleaseFillAValidEmailAddress: '请填写有效的业务电子邮件。',
      businessEmailIsRequired: '业务电子邮件为必填项。',
      phoneNumberShouldHaveMinimum7Digits: '电话号码应至少为7位数字',
      phoneNumberIsRequired: '电话号码为必填项',
      websiteIsRequired: '需要网站。',
      maximumLengthForWebsite40Characters: '网站的最大长度为40个字符。',
      maximumLengthForAddress150Characters: '地址的最大长度为150个字符。',
      doYouHaveWhatsappApiKey: '您是否有WhatsApp API密钥？',
      apiProvider: 'API提供商',
      three60Dialog: '360对话',
      whatsappCloud: 'WhatsApp云',
      netcore: 'Netcore',
      apiKeyIsRequired: 'API密钥为必填项。',
      whatsappBusinessAccountIdIsRequired: 'WhatsApp业务账户ID为必填项。',
      whatsappPhoneNumberIdIsRequired: 'WhatsApp电话号码ID为必填项。',
      systemAccessTokenIsRequired: '系统访问令牌为必填项。',
      sourceIdIsRequired: '源ID为必填项。',
      businessName: '业务名称',
      businessAccount: '业务账户',
      businessDescription: '业务描述',
      address: '地址',
      businessEmail: '业务电子邮件',
      websiteUrl: '网站URL',
      thankYouForYourInterestIn: '感谢您对',
      whatsappChatBot: ' WhatsApp聊天机器人的兴趣。',
      weHaveReceivedYourInterests: '我们已收到您的兴趣，我们的销售团队将在接下来的24小时内与您联系。',
      theyWillProvideYouWhatsappApiKey: '他们将为您提供WhatsApp API密钥。',
      readyToCreateWhatsappBot: '我准备好创建WhatsApp机器人',
      exploreWhatsappFeatures: '探索WhatsApp功能',
      welcomeToBrandNameWeAreHereToHelpYou: `欢迎来到${brand}。我们在这里帮助您。`,
      letsTryYourBotAndSeeHowItWorks: `让我们尝试您的机器人并看看它如何工作！点击“在WhatsApp上测试”。`,
      howAreYouDoingToday: '你今天好吗？',
      thisIsHowSimpleToUseWhatsappBot: '就是这样！使用WhatsApp机器人是多么简单',
      letsCreateYourOwnChatFlowNow: `现在让我们创建您自己的聊天流程`,
      connectWhatsAppBot: '连接WhatsApp机器人',
      createtWhatsAppBot: '填写您的业务详细信息',
      proceed: '继续',
      whatsApiProvider: 'WhatsApp API提供商',
      cloudApi: '云API',
      netcoreApi: 'Netcore API',
      loginWithFacebook: '使用Facebook登录WhatsApp Onboarding',
      asPerLatestChangesInFacebook: '根据Facebook政策的最新更改，Facebook机器人所有者必须具有管理员角色以访问所有功能。',
      login: '登录',
      successWhatsAppOnboarding: '成功！WhatsApp帐户已获批准！',
      congratulationYourWhatsApp: '恭喜您，您的WhatsApp号码已经获得批准。更新您的付款方式以开始使用您的机器人。',
      sendFirstMessage: '发送第一条消息',
      editYourChatFlow: '编辑您的聊天流程',
      overview: '概述',
      oopsErrorOccurred: '糟糕！在Onboarding过程中发生错误',
      oopsSomethingWentWrong: '糟糕！在Onboarding过程中出现问题。请查看您的信息并重试。如果问题仍然存在，请联系我们的支持团队寻求帮助。',
      setupManually: '手动设置',
      retryWithAutomatedOnboarding: '使用自动Onboarding重试',
      placeholders: {
        yourBusinessName: '您的业务名称',
        businessDescription: '业务描述',
        businessEmail: '业务电子邮件',
        phone: '电话*',
        website: '网站（例如www.example.com）',
        address: '地址',
        enterApiKey: '输入API密钥',
        enterWhatsappBusinessAccountId: '输入WhatsApp业务帐户ID',
        enterWhatsappPhoneNumberId: '输入WhatsApp电话号码ID',
        enterSystemAccessToken: '输入系统访问令牌',
        enterSourceId: '输入源ID',
        businessName: '业务名称',
        businessWebsite: '业务网站',
        selectWhatsappApiProvider: '选择WA API提供商',
      },
      stepFour: {
        chooseYourWhatsAppAPIProvider: '选择您的WA API提供商',
        doYouHaveWhatsAppBusinessAPI: '您是否拥有WhatsApp Business API？',
        yes: '是的',
        noIAmNotSure: '不确定',
        selectApiProvider: '选择API提供商',
        whatsAppCloudAPI: 'WhatsApp云API',
        enterYourPhoneNumberId: '输入您的电话号码ID',
        phoneNumberId: '电话号码ID',
        enterYourWhatsAppBusinessAccountId: '输入您的WhatsApp业务帐户ID',
        whatsAppBusinessAccountId: 'WhatsApp业务帐户ID',
        enterYourSystemUserToken: '输入您的系统用户令牌',
        systemUserToken: '系统用户令牌',
        help: '帮助',
        netcoreAPI: 'Netcore API',
        enterYourSourceId: '输入您的源ID',
        sourceId: '源ID',
        enterYourNetcoreApiKey: '输入您的Netcore API密钥',
        netcoreApiKey: 'Netcore API密钥',
        submit: '提交',
        noneOftheAbove: '以上都不是',
        next: '下一步'
      },
      stepTwo: {
        legallyRegisteredBusiness: '合法注册的业务',
        validWebsiteWithDataPrivacyPolicy: '具有数据隐私政策的有效网站',
        debit: '借记卡',
        creditCard: '信用卡',
        gstin: 'GSTIN',
        onlyRequiredForIndianResidents: '仅适用于印度居民',
        onlyRequiredFor: '仅适用于',
        indianResidents: '印度居民',
        validPaymentMethod: '有效的付款方式',
        enabledWithInternationalPayments: '启用国际支付',
        validUseCaseInComplianceWithWhatsAppCommercePolicy: '符合WhatsApp商务政策的有效用例',
        PhoneNumberWhichDoesNotHaveActiveWhatsAppAndCapableOfReceivingTheSMS: '没有激活WhatsApp并能够接收短信的电话号码',
        discard: '丢弃',
        proceed: '继续',
        whatsAppBotPrerequisites: 'WhatsApp机器人先决条件',
        letUsGetItDoneForYou: '让我们为您完成！',
        ifYouAreFacingSomeIssues: '如果您遇到问题',
        ourTeamCanHelpYouDoTheSame: '我们的团队可以帮您做同样的事情',
        requestACallbackNow: '立即请求回电！',
      },
      stepThree: {
        setupWhatsAppBot: '设置WhatsApp机器人',
        selectingTheBestBusinessManagerForYourNeeds: '选择最适合您需求的最佳业务经理',
        createMetaApp: '如何创建Meta应用',
        createaMetaAppOn: '在上创建Meta应用',
        howToCreate: '如何创建',
        addWhatsAppNumber: '添加WhatsApp号码',
        addYourWhatsAppNumberAndVerifyTheSame: '添加您的WhatsApp号码并进行验证',
        subscribe: '订阅',
        copyAndSubscribeWebhook: '复制并订阅Webhook',
        howToSubscribe: '如何订阅',
        copy: '复制',
        appSecretId: '应用程序密钥ID',
        enterYourAppSecretId: '输入您的应用程序密钥ID',
        enterAppSecret: '输入应用程序密钥',
        phoneNumberId: '电话号码ID',
        whatsAppBusinessId: 'WhatsApp业务ID',
        assignSystemUser: '如何分配系统用户',
        assign: '分配',
        createApp: '创建Meta',
        registerAndVerify: '注册并验证',
        add: '添加',
        systemUserToken: '系统用户令牌',
        enterYourSystemUserToken: '输入您的系统用户令牌',
        getAllNecessaryDetails: '如何获取所有必要的详细信息',
        subscribeWhatsAppWebhook: '如何订阅WA Webhook',
        configureTheWebhookForWhatsAppAccount: '为WhatsApp帐户配置Webhook',
        upadatePaymentMethod: '如何更新付款方法',
        assignThePaymentMethodToWhatsAppAccount: '将付款方式分配给任何WhatsApp帐户',
        grantControlOfWhatsAppBusinessAccountToASystemUser: '将对WhatsApp Business Account的控制权授予系统用户',
        keyDetailsThatYouNeedToCopyFromMetaDashboard: '您需要从Meta仪表板复制的关键详细信息',
        updatePayment: '更新付款',
        letUsGetItDoneForYou: '让我们为您完成！',
        ifYouAreFacingSomeIssues: '如果您遇到问题',
        ourTeamCanHelpYouDoTheSame: '我们的团队可以帮您做同样的事情',
        requestACallbackNow: '立即请求回电！',
        update: '更新',
        connectNow: '立即连接'
      },
      stepFive: {
        selectBusinessManager: '选择业务经理',
        selectingTheBestBusinessManagerForYourNeeds: '选择最适合您需求的最佳业务经理'
      },
      stepSix: {
        yourBotIsInstalledAndActive: '您的机器人已安装并激活',
        youhaveSuccessfullyConnected: '您已成功连接',
        withWhatsApp: '与WhatsApp',
        youHaveBeenAllocaated100ConversationsPerMonthByDefault: '默认情况下，您已被分配每月100次对话',
        upgradeYourPlanForMore: '升级您的计划以获取更多功能。',
        createChatFlow: '创建聊天流程',
        upgradePlan: '升级计划'
      },
      activeDemoBotStepFive: {
        scanQrOrSendMessageToActivateBot: '扫描QR码或发送消息以激活机器人',
        scanTheQrCodeFrom: '从扫描QR码',
        yourPhoneWillOpen: '您的手机将打开一个预填充的消息以发送到我们的沙盒号码。在WhatsApp上点击“发送”',
        sendMessageFromYourWhatsAppNumber: '从您的WhatsApp号码发送消息',
        sendUsAWhatsAppMessageOn: '在WhatsApp上给我们发消息',
        bySavingInYourContactsAndMessageShouldStartwith: '通过保存在您的联系人中，并且消息应以以下方式开始 ',
        send: '发送',
        or: '或'
      },
      phoneNumberSetup: {
        waPhoneNoSetup: 'WhatsApp 电话号码设置',
        loginWithFb: '使用 Facebook 登录进行嵌入式 WhatsApp 启用',
        continueWithFb: '继续使用 Facebook',
        connectAPIKey: '使用 API Key 连接',
        apiKeyContinue: '如果您已经有验证过的号码和 API Key，请按以下步骤继续设置',
        connectWaNo: '连接 WhatsApp 号码'
      }
    }
  },
  gettingStarted: {
    hello: '你好，',
    upgrade: '升级',
    gettingStarted: '入门 - ',
    yourFacebookBotToken: '您的Facebook机器人令牌 ',
    hasBeenExpired: '已过期',
    isExpiringIn: '将在 ',
    days: ' 天后过期',
    facebookAuthenticationTokenRemainsFor60Days: 'Facebook身份验证令牌仅保持活动状态60天',
    kindlyProceedWithTheRenewalOfYourBotToken: '请继续续订您的机器人令牌，以确保无中断访问聊天机器人服务。',
    renewYourBotToken: '续订您的机器人令牌',
    editYourChatFlow: '编辑您的聊天流程',
    buildConversationEngagingBot: '为您的机器人用户构建引人入胜的对话流程。',
    takes5minutes: '只需5分钟',
    previewYourLiveChatWidget: '预览您的实时聊天小部件',
    discoverHowThe: '了解 ',
    liveChatFeatureWorks: ' 实时聊天功能如何运作，使用我们的实时聊天游乐场',
    takes2minutes: '只需2分钟',
    takes1minute: '只需1分钟',
    connected: '已连接',
    customizeYourBotApperance: `自定义您机器人的外观和功能。`,
    takes3minutes: '只需3分钟',
    thirdPartyAppsIntegration: '第三方应用集成',
    integrateYourBot: '将您的机器人与其他应用/CRM集成，创建业务自动化。',
    upgradeYourPlanToReceiveLeadsInEmail: '升级您的计划以通过电子邮件接收潜在客户',
    getStartedWithUs: '与我们一起开始',
    howToBuildAGoodChatFlow: '如何构建良好的聊天流程',
    howToUseBotPenguinsInboxAndItsFeatures: '如何使用BotPenguin的收件箱及其功能',
    botPenguinsPricing: 'BotPenguin的定价：探索计划和功能',
    openHelpDesk: '打开帮助台',
    helpAndSupport: '帮助和支持',
    extensiveGuides: '我们的 ',
    resourceCentre: '资源中心',
    checkoutOurAnswers: '您可以在下面检查我们对常见问题的答案。',
    createANewBot: '创建新机器人',
    installYourBot: '安装您的机器人',
    plansAndPricing: '计划和价格',
    previewYourLandingPageBot: '预览您的着陆页机器人',
    installYourLiveChatWidget: '安装您的实时聊天小部件',
    installYourWebsiteBot: '将机器人安装到网站、移动应用程序，或作为着陆页或嵌入式聊天机器人启动',
    integrateBotToLandingPage: '将机器人集成到着陆页机器人',
    installWidgetToWebsite: '将小部件安装到您的网站',
    installBotToWebsite: '安装您的聊天机器人',
    whatsappAutomation: 'WhatsApp自动化',
    facebookAutomation: 'Facebook自动化',
    telegramBotSettings: 'Telegram机器人设置',
    liveChatWidgetSettings: '实时聊天小部件设置',
    landingPageBotSettings: '着陆页机器人设置',
    websiteChatBotSettings: '网站聊天机器人设置',
    instagramAutomation: 'Instagram自动化',
    diveDeeperIntoBotPenguin: '深入了解BotPenguin',
    knowWhereWeAreGoing: '了解我们的目标、最新更新，并帮助我们修复一些错误。',
    productUpdates: '产品更新',
    requestAFeature: '提出建议',
    reportABug: '报告错误',
    prodcutRoadmap: '产品路线图',
    trainYourChatbot: '培训您的AI聊天机器人（知识库）',
    buildEngagingConversation: '为您的机器人用户构建引人入胜的对话流程。',
    previewYourAIBot: '预览您的AI机器人',
    integrateAIbot: '将机器人集成到您的AI机器人',
    aiBotSettings: 'AI机器人设置',
    CustomizeAIBot: '自定义您的机器人的外观和功能。',
    gptKeyWarning: '注意：您每个机器人最多可以使用100条GPT消息。要继续使用超出设定限制的服务，请点击“添加API密钥”按钮输入您的ChatGPT API密钥。',
    whatsappBotSettings: 'WhatsApp机器人设置',
    automateCustomerEngagementWithWhatsApp: '使用WhatsApp自动化客户参与。',
    connectToYourWhatsappNumber: '连接到您的WhatsApp号码',
    connectYourWhatsappBotWithYourWhatsappNumber: '将WhatsApp机器人连接到您的WhatsApp号码',
    facebookBotSettings: 'Facebook机器人设置',
    automateCustomerEngagementWithTelegram: '使用Telegram自动化客户参与',
    automateCustomerEngagementWithFacebook: '使用Facebook自动化客户参与',
    automateCustomerEngagementWithInstagram: '使用Instagram自动化客户参与',
    telegramAutomation: 'Telegram自动化',
    limitExhaustMessage: '您已达到免费100条AI消息的最大限制。要继续使用我们的ChatGPT API服务，请点击“添加API密钥”按钮输入您的ChatGPT API密钥。',
    addApiKey: '添加API密钥'
  },
  install: {
    previewYourLandingPageBot: '预览您的着陆页机器人',
    preview: '预览',
    test: '测试',
    squareSpace: 'Squarespace',
    installYourChatBot: '安装您的聊天机器人',
    seeHowToUse: '查看如何使用',
    help: '帮助',
    uniqueLinkToLandingPageBot: '这是您的着陆页机器人的唯一链接。',
    shareOnSocialMedia: '只需在社交媒体、联系页面或名片上与用户共享它。',
    or: '或',
    copyUrl: '复制链接',
    selectYourWebsiteCms: '选择您的网站 CMS',
    selectCms: '选择您用于创建网站的 CMS/构建工具',
    custom: '自定义',
    wordpress: 'WordPress',
    shopify: 'Shopify',
    wix: 'Wix',
    zoomla: 'Zoomla',
    otherCms: '其他 CMS',
    howWouldYouLikeToInstall: '您希望如何安装？',
    installingWebsiteBot: '选择在您的网站上安装机器人的方式',
    iWillAddMyself: '我会自己添加',
    getChatBotScript: '获取下面的聊天机器人脚本代码，然后自行安装',
    getWordpressPlugin: '获取 WordPress 插件 API 密钥',
    getOurOfficialPlugin: '从 WordPress 插件商店获取我们的官方插件 ',
    fromWordpressPluginStore: ' 从 WordPress 插件商店',
    getPlugin: '获取插件',
    quickGuideToInstall: '安装的快速指南',
    placeApiKeyBelowIn: '在下载并激活插件后，将 API 密钥粘贴在以下位置',
    afterDownloadingAndActivatingPlugin: '在下载并激活插件后',
    copy: '复制',
    enterYourWebsite: '输入您的网站，让我们看看您的聊天机器人是什么样的',
    enterAValidUrl: '输入有效的 URL',
    verifyYourInstallation: '验证您的安装是否成功？',
    testInstallation: '测试安装',
    getChatBotScriptCode: '获取聊天机器人脚本代码',
    copyThisCodeSnippet: '复制此代码片段并将其插入每个要显示聊天机器人的网页的 HTML 中' +
      '或在每个页面的页脚中插入标签之前。',
    sendCodeToMyDeveloper: '将代码发送给我的开发人员',
    sendCodeToMyDevelopmentTeam: '将代码发送给我的开发团队',
    sendEmail: '发送电子邮件',
    enterAValidEmail: '输入有效的电子邮件',
    codeHasBeen: '代码已被',
    toYourDeveloper: '发送到您的开发人员 ',
    resent: '重新发送',
    sent: '已发送',
    resendEmail: '重新发送电子邮件',
    ask: '询问',
    supportTeamToInstall: '支持团队进行安装',
    raiseTheInstallationRequestTo: '将安装请求提升给',
    team: ' 团队',
    helpMeInstallingChatBot: '帮助我安装聊天机器人',
    yourBotInstallationIsNotActive: '您的机器人安装未激活！',
    monthlyMessageLimitExceeded: '超过每月消息限制',
    exceededMonthlyMessageLimitUpgradeNow: '您已超过每月消息限制，请立即升级。',
    upgradeNow: '立即升级',
    botInstallationNotActivePleaseFix: '您的机器人安装未激活，请修复。',
    incorrectBotScript: '不正确的机器人脚本',
    installationCodeYouAreVerfiyingNotMatchingOnYourSite: '您正在验证的安装代码与您网站上的代码不匹配。' +
      '请确保您已安装了此机器人的正确代码。',
    unableToSee: '无法看到 ',
    codeOnYourWebsite: ' 您网站上的代码',
    unableToFindCodePleaseReinstall: '我们无法找到您网站上的代码，请重新安装。',
    reinstallBot: '重新安装机器人',
    yourBotIsInstalledAndActive: '您的机器人已安装并激活！',
    noPendingAction: '没有待处理的操作，您的机器人已安装并激活',
    youAreAllSet: '您已准备就绪！',
    showMeMyLeads: '显示我的潜在客户',
    connectingToYourWebsiteToVerifyInstallation: '连接到您的网站以验证机器人安装',
    thisMayTakeUpto30Seconds: '这可能需要最多 30 秒',
    hereIsTheuniqueAILink: '这是您的 AI 机器人的唯一链接',
    installHeading: '安装您的聊天机器人',
    websiteChatbot: '网站聊天机器人',
    aiChatBot: 'AI 聊天机器人',
    landingPageBot: '着陆页机器人',
    mobileChatBot: '移动应用聊天机器人',
    embeddedBot: '嵌入式聊天机器人',
    selectMobileDevice: '选择您的移动设备',
    mobileDeviceSubheading: '选择您用于创建移动应用的本地语言',
    ios: 'IOS',
    android: 'Android',
    reactNative: 'React Native',
    otherMobileDevice: '其他',
    copyEmbeddedCodeSnippet: '复制此代码片段并将其插入要显示聊天机器人的每个网页的 HTML 中。',
    copyMobileCodeSnippet: '复制此代码片段并将其插入您的移动应用程序代码中，以在其中显示聊天机器人。',
    placeholders: {
      exampleSite: 'https://www.yoursite.com',
      enterDeveloperEmail: '输入开发人员电子邮件'
    },
    installGeneral: {
      sendInstructionsToYourDeveloper: '将说明发送给您的开发人员',
      notSureHowToDoIt: '不确定如何做？您的开发人员可以很快完成。',
      developersEmail: '开发人员的电子邮件',
      emailIsRequired: '电子邮件是必填项',
      subject: '主题',
      message: '消息',
      send: '发送',
      placeholders: {
        enterYourWorkEmail: '输入您的工作电子邮件',
        createBotUsingBotPenguin: '激动人心！使用 BotPenguin 创建机器人',
      }
    },
    platforms: {
      hereIsUniqueLinkToLandingPageBot: '这是您的着陆页机器人的唯一链接。',
      shareWithUsersOnSocialMedia: '只需在社交媒体、联系页面或名片上与用户共享它。',
      previewMyLandingPageBot: '预览我的着陆页机器人',
      or: '或',
      copyUrl: '复制链接',
      howYouLikeToAddBot: '选择要添加 Bot 代码到您的网站的方式',
      installTheBotToYourCustomCodedOrWordPressWebsite: '通过复制粘贴唯一代码，将 Bot 安装到自定义编码或 WordPress 网站。',
      name: '名称',
      actions: '操作',
      javascript: 'JavaScript',
      install: '安装 ',
      onYourCustomCodedWebsite: ' 在您的自定义编码网站上',
      copyAndPaste: '复制并粘贴',
      copyThisCodeSnippet: '复制此代码片段并将其插入要显示 Widget 的每个网页的 HTML 中。有关详细信息',
      seeGuide: '请查看指南',
      getCode: '获取代码',
      howToInstall: '如何安装？',
      copyCode: '复制代码',
      wordpress: 'WordPress',
      onYourWordPressWebiste: ' 在您的 WordPress 网站上',
      preview: '预览',
      test: '测试',
    }
  },
  liveChatPreview: {
    liveChatPreview: '实时聊天预览',
    agentWindow: '客服窗口',
    person: '人',
    inOrderToTestTypeHere: '为了测试，请在此输入',
    agentWindowCannotBeCustomized: '注意：客服窗口无法定制',
    customerWindow: '客户窗口',
    clickHereToChat: '点击这里开始聊天',
    customerWillChatHere: '客户将在此聊天',
    chat: '聊天',
    by: '通过',
    changeYourBotLookFromLeftPanel: '从左侧面板更改您的机器人外观',
    placeholders: {
      typeYourMessage: '输入您的消息...',
      typeYourAnswer: '输入您的答案',
    }
  },
  previews: {
    previewYourLiveChatWidget: '预览您的实时聊天小部件',
    install: '安装',
    seeHowToUse: '查看如何使用',
    appTooltip: {
      clickToInstallYourBotToSelectedPlatform: '点击安装您的机器人到选定的平台',
    }
  },
  trainYourBot: {
    trainYourBot: '培训您的AI聊天机器人',
    knowledgeBase: '知识库',
    faqs: '常见问题',
    history: '历史',
    faqHeading: '常见问题',
    faqSubHeading: '培训您的聊天机器人以提供准确的答案。',
    knowledgeBaseHeading: '培训您的聊天机器人',
    knowledgeBaseSubheading: '培训您的聊天机器人，提升对话效果',
    websiteLink: '网站链接',
    uploadFile: '上传文件',
    selectFile: '选择文件',
    submit: '提交',
    searchHere: '在此搜索',
    question: '问题',
    answer: '答案',
    questionPlaceholder: '在此输入您的问题',
    answerPlaceholder: '在此输入您的答案',
    save: '保存',
    discard: '放弃',
    addFaq: '添加常见问题',
    createdAt: '创建于',
    updatedAt: '上次更新于',
    actions: '操作',
    noFaqFound: '您尚未创建任何常见问题',
    noFaqFoundMessage: '您的所有常见问题将显示在此处',
    historyTitle: '知识库历史',
    historySubtitle: '您的聊天机器人培训问题的答案',
    fileName: '文件名',
    status: '状态',
    noHistoryTitle: '您尚未创建任何已培训模型',
    noHistoryDescription: '您的所有已培训模型将显示在此处',
    fileUpload: '文件上传',
    files: '文件',
    fileSubHeading: '上传所有用于培训AI聊天机器人的文件。',
    noFileFoundHeading: '您尚未上传任何文件。',
    noFileFoundSubheading: '您的所有文件将显示在此处',
    uploadYourFiles: '上传您的文件',
    upload: '上传',
    fileShouldBe: '文件应为PDF、DOC、DOCX、PPTX或TXT格式。',
    uploadStatus: '上传状态',
    uploadStatusSubHeading: '用于机器人培训的文件上传状态',
    addFile: '添加文件',
    otherConfiguration: 'AI设置',
    deleteFiles: '单击以删除文件',
    websiteURL: '网站网址',
    websiteUrlSubheading: '添加用于培训AI聊天机器人的网站网址。',
    enterWebsiteUrl: '输入网址',
    addWebsite: '添加网站',
    tableWebsiteUrl: '网站网址',
    trainingStatus: '培训状态',
    lastTrained: '上次培训于',
    noWebsitesFound: '尚未爬取任何网站！',
    noWebsitesFoundMessage: '您的所有网站将显示在此处',
    loadMore: '加载更多',
    botBehaviour: '配置机器人行为',
    botBehaviourSubHeading: '配置机器人的个性、处理流程和ChatGPT模型',
    botPersonality: '配置机器人的个性',
    botPersonalitySubHeading: '管理机器人在个性方面的回应方式',
    selectAnswerLength: '选择答案长度',
    answerLength: '答案长度',
    answerAs: '答案作为',
    tone: '语气',
    language: '语言',
    answerFormatting: '答案格式',
    customInstructions: '自定义提示',
    customerInstructionPlaceholder: '礼貌友好，不使用俚语，不使用表情符号',
    redactCustomerData: '收集客户数据',
    redactDataSubheading: '配置要收集的客户信息',
    collectName: '收集姓名',
    configureQuestion: '配置问题',
    maxCharacterLimit: '提供姓名的最大字符限制',
    collectEmail: '收集电子邮件',
    excludeEmail: '排除带有域的电子邮件',
    collectPhone: '收集电话',
    manageUnusualMessages: '处理异常聊天情景',
    unusualMessagesSubheading: '处理无法回答的和其他罕见情景的机器人',
    startConversation: '开始对话的消息',
    configureMessage: '机器人无法回答时的消息',
    profanityMessage: '回应不当语言使用的消息',
    chatGptModel: 'ChatGPT模型配置',
    chatGptModelSubheading: '管理使用哪个ChatGPT模型，避免滥用',
    chatGptApi: 'ChatGPT API密钥',
    enableDisableRedactData: '收集客户数据',
    triggerToCollectData: '在一系列问题后收集联系方式。',
    train: '培训',
    website: '网站',
    analytics: '分析',
    conversationsHistory: '对话历史',
    exportCustomerConversation: '导出客户对话以用于AI聊天机器人培训。',
    includedSourcesForResponse: '包含在响应中的来源',
    visibility: '可见性',
    yourConversation: '您的对话',
    reviewAndSelectConversation: '查看并选择导出聊天机器人培训的对话',
    exportAiAnalytics: '导出分析',
    startDate: '开始日期',
    endDate: '结束日期',
    userQuestion: '用户的问题',
    botsReply: '机器人的回复',
    dateCreated: '创建日期',
    noAnalyticsFound: '没有找到对话。',
    noAnalyticsFoundMessage: '您的所有机器人交互将显示在此处。',
    detectYourLanguage: '检测用户的语言并以相同语言回应',
    exportData: '导出数据',
    exportCompleteAnalyticsData: '导出完整的分析数据',
    export: '导出',
    integrateWithChatGpt: '与ChatGPT集成',
    integrated: '已集成',
    connected: '已连接',
    gpt3: 'GPT-3.5（较低成本，平均准确度）',
    gpt4: 'GPT-4（较高成本，较高准确度）',
    gptAssistant: '助手Beta*（高级成本，卓越准确度）',
    configure: '配置',
    prompt: '提示',
    vectorResult: '矢量结果',
    personalizeReplies: '通过Chat History个性化回复',
    personalizeRepliesNote: '注意：启用此功能会增加标记大小并影响ChatGPT执行成本。',
    appToolTip: {
      deleteWebsite: '删除网站',
      knowledgeBase: '使用知识库培训您的机器人',
      faqs: '使用常见问题培训您的机器人',
      knowledgeHistory: '知识库历史',
      uploadFaqs: '上传常见问题以培训您的AI聊天机器人',
      addFaqs: '单击以添加用于培训您的AI聊天机器人的常见问题',
      deleteFaqs: '删除常见问题',
      deleteHistory: '删除历史',
      uploadFile: '上传文件必须为pdf、docx、doc或csv格式，大小不超过1 MB。',
      trainWebsite: '使用网站培训您的机器人。',
      fileUpload: '通过上传文件（如PDF、TXT、PPTX、DOC和DOCX）培训您的机器人。',
      configureBotBehaviour: '自定义机器人的个性，管理流程，并调整ChatGPT模型。',
      clickToAddWebsite: '单击以添加用于培训您的AI聊天机器人的网站网址。',
      clickToAddFile: '单击上传所有用于培训您的AI聊天机器人的文件',
      clickToDeleteWebsites: '单击删除网站',
      syncWebsite: '同步网站',
      copyUrl: '复制网址',
      weWillBeFetchingAllTheWebpages: '我们将获取所有网页并在它们上训练ChatGPT模型。'
    },
    modal: {
      deleteWebsiteUrl: '删除网站网址',
      areYouSureYouWantToDeleteThisWebsiteUrl: '您确定要删除此网站网址吗？'
    }
  },
  configuration: {
    websiteChatbotSetting: '网站聊天机器人设置',
    preview: '预览',
    test: '测试',
    install: '安装',
    designHeader: '设计',
    generalHeader: '常规',
    alertsHeader: '警报',
    triggerHeader: '触发器',
    userAccessHeader: '用户访问',
    chatWindowHeader: '聊天窗口',
    otherConfiguration: 'AI 设置',
    appTooltip: {
      clickToInstallYourBotToSelectedPlatform: '点击安装您的机器人到选定的平台',
      customizeAppearanceOfBot: '自定义机器人界面的定位和外观。',
      configureBotsSettingsWhenAgentUnavailable: '在您的代理不可用时配置机器人的设置。',
      configureHowBotWillAlertYou: '配置机器人如何通知您有新线索。',
      makeSureYourBotsPopUpProperlyTimed: '确保您的机器人弹出窗口的时间安排得当。',
      customizeWhereYouWantYourBotToAppear: '自定义您希望机器人出现的位置以及不希望出现的位置。',
      enableChatOptionsForVisitorsToTransferChat: '启用访客将聊天、实时聊天和刷新聊天转移的聊天选项。',
      configureBotBehaviour: '自定义机器人的个性、管理流程并调整 ChatGPT 模型。',
    },
    alerts: {
      configureYourBotsAlertSettings: '配置机器人的警报设置',
      specifyHowYourBotWillNotify: '指定机器人将如何通知您有关新线索的方式。',
      subject: '主题',
      emailNotification: '电子邮件通知',
      emailAddresses: '电子邮件地址',
      leadRevisitNotification: '线索再访通知',
      youHaveSuccessfullyRegisteredWithDesktopNotifications: '您已成功注册桌面通知',
      youHaveBlockedYourNotificationsOnBrowser: '您已在浏览器设置中阻止通知。',
      discard: '丢弃',
      saveChanges: '保存更改',
      seeHowToUse: '查看如何使用',
      placeholders: {
        enterSubjectForYourEmail: '为您的电子邮件输入主题',
        typeYourEmailAddressAndHitEnter: '输入您的电子邮件地址并按回车',
      },
      appTooltip: {
        TOOLTIP_SUBJECTS: '自定义机器人电子邮件通知的主题',
        TOOLTIP_EMAIL_NOTIFICATION: '启用/禁用机器人在新线索的电子邮件通知上的通知',
        TOOLTIP_EMAIL_ADDRESS: '提交您希望接收电子邮件通知的帐户的电子邮件地址。您可以通过输入一个并按回车键添加另一个来添加多个电子邮件地址。',
        TOOLTIP_LEAD_REVISIT_NOTIFICATION: '如果先前被捕获为线索的用户再次与机器人交互，则启用/禁用机器人的电子邮件通知。',
      }
    },
    broadcasts: {
      createBroadcastHeading: '创建广播',
      youCanCreateMultipleBroadcasts: '您可以创建多个广播',
      broadcastName: '广播名称',
      broadcastNameIsRequired: '广播名称是必需的',
      continue: '继续',
      manageBroadcasts: '管理广播',
      youCanCreateMultipleBroadcastsWithMultipleTemplatesAndSegments: '您可以创建具有不同客户组的多个计划模板的多个广播。',
      createNewBroadcast: '创建新广播',
      name: '名称',
      segment: '群组',
      template: '模板',
      contacts: '联系人',
      send: '发送',
      delivered: '已发送',
      read: '已读',
      failed: '失败',
      broadcastAt: '广播时间',
      status: '状态',
      actions: '操作',
      nA: '不适用',
      seeHowToUse: '查看如何使用',
      deleteBroadcast: '删除广播',
      wantToDeleteThisBroadcast: '您确定要删除此广播吗？',
      placeholders: {
        searchHere: '在此搜索',
        enterBroadcastName: '输入广播名称',
      },
      appTooltip: {
        deleteMultipleBroadcasts: '删除多个广播',
        broadcastAnalytics: '广播分析',
        deleteBroadcast: '删除广播',
      },
      broadcastAnalytics: {
        broadcastInsights: '广播洞察',
        broadcastStatus: '广播状态',
        youCanFindDetailsOfEachContactBelow: '您可以在下方找到每个联系人的详细信息，并导出可能存在问题的联系人。',
        filterApplied: '已应用筛选器',
        placeholders: {
          searchByPhoneNumber: '按电话号码搜索',
          searchByName: '按姓名筛选',
        },
        appTooltip: {
          filterDataBasedOnStatus: '根据状态筛选数据',
          exportData: '导出数据',
        },
        modal: {
          exportData: '导出数据',
          exportCompleteBroadcastData: '导出完整的广播数据',
          export: '导出',
        }
      },
      createBroadcast: {
        broadcastName: '广播名称',
        broadcastNameIsRequired: '广播名称是必需的',
        template: '模板',
        segments: '群组',
        whenToSend: '何时发送',
        now: '现在',
        later: '稍后',
        selectBroadcastUsing: '选择使用广播',
        usingCsv: '使用 CSV',
        usingSegment: '使用群组',
        allContacts: '所有联系人',
        selectDate: '选择日期',
        selectTimeSlot: '选择时间段',
        assignVariablesToTemplates: '为模板分配变量',
        addHeaderMedia: '添加标题媒体',
        selectFile: '选择文件',
        cancel: '取消',
        createBroadcast: '创建广播',
        broadcastUsing: '广播使用',
        selectCSVFile: '选择 CSV 文件',
        importContacts: '导入联系人',
        beforeYouStartUpload: '在开始上传之前，请确保',
        point1: '1. 下载示例 CSV 文件。',
        point2: '2. 从第二行开始输入您的数据。',
        point3: '3. 每行中将有一个联系人的数据',
        point4: '4. 确保所有电话号码都是唯一的。',
        point5: '5. 最大文件大小上传限制为 20MB',
        clickHere: '点击这里',
        toDownloadSampleFile: '下载示例文件',
        placeholders: {
          enterBroadcastName: '输入广播名称',
          selectTemplate: '选择模板',
          searchTemplateByName: '按名称搜索模板',
          selectSegments: '选择群组',
          selectTimeSlot: '选择时间段',
          selectValueForThisVariable: '为此变量选择值',
          searchHeaderByVariableName: '按名称搜索标题变量',
          variableFallbackValue: '变量回退值',
          searchBodyVariableByName: '按名称搜索正文变量',
          searchSegmentByName: '按名称搜索群组',
          selectBroadcastUsing: '选择使用广播',
        },
        indexMergeDatePicker: {
          selectStartDate: '选择开始日期',
        },
        appTooltip: {
          importContactsForWhatsappBroadcast: '为 WhatsApp 广播导入联系人',
        }
      },
      failedBroadcast: {
        whatsappNumber: 'WhatsApp 号码',
        errorCode: '错误代码',
        errorMessage: '错误消息',
        nA: '不适用',
      }
    },
    design: {
      customizeYourLandingPage: '自定义您的登录页面',
      customizeYourConversationalBot: '自定义您的AI机器人',
      customizeYourBot: '自定义您的机器人',
      createHeadingTextAndTheme: '创建反映您品牌个性的标题文本和主题',
      content: '内容',
      theme: '主题',
      layout: '布局',
      landingPageName: '登录页面名称',
      botName: '机器人名称',
      charactersRemaining: '剩余字符',
      landingPageHeader: '登录页面标题',
      landingPageDescription: '登录页面描述',
      hideContent: '隐藏内容',
      profilePic: '头像',
      selectFile: '选择文件',
      socialMediaLinks: '社交媒体链接',
      initialMessage: '对话机器人初始消息',
      flowTriggerDetail: '触发收集联系方式',
      selectType: '选择类型',
      url: 'URL',
      delete: '删除',
      editLink: '编辑链接',
      addLink: '添加链接',
      callToAction: '呼叫动作',
      liveChatWelcomeMessage: '实时聊天欢迎消息',
      liveChatTriggerMessage: '实时聊天触发消息',
      autoHideCallToAction: '自动隐藏呼叫动作',
      maxDelayShouldBe300Seconds: '最大延迟应为300秒',
      landingPageThemeColor: '登录页面主题颜色',
      themeColor: '主题颜色',
      landingPageBackground: '登录页面背景',
      chatBackgroundColor: '聊天背景颜色',
      color: '颜色',
      gradient: '渐变',
      image: '图片',
      video: '视频',
      gradientStart: '渐变开始',
      gradientEnd: '渐变结束',
      positionOnWeb: '在网页上的位置',
      positionOnMobile: '在移动设备上的位置',
      windowSize: '窗口大小',
      s: 'S',
      m: 'M',
      l: 'L',
      xl: 'XL',
      xxl: 'XXL',
      custom: '自定义',
      height: '高度',
      minimum300HeightIsRequired: '最低要求300px高度',
      heightCannotExceed720: '高度不能超过720px',
      width: '宽度',
      px: '像素',
      minimum200WidthIsRequired: '最低要求200px宽度',
      widthCannotExceed1050: '宽度不能超过1050px',
      discard: '放弃',
      saveChanges: '保存更改',
      landingPageBot: '登录页面机器人',
      chatBot: '聊天机器人',
      preview: '预览',
      botIcon: '机器人图标',
      websiteBot: '网站聊天机器人',
      selectFont: '选择字体',
      fontLibrary: '字体库',
      uploadFont: '上传字体',
      selectFontForBot: '为机器人选择字体',
      uploadedFont: '已上传的字体',
      placeholders: {
        enterName: '输入名称',
        enterHeaderText: '输入标题文本',
        enterDescription: '输入描述',
        enterUrl: '输入URL',
        howCanIHelpYou: '我能如何帮助您？',
        enterYourWelcomeMessageHere: '在此输入您的欢迎消息',
        enterYourLiveChatMessageHere: '在此输入您的实时聊天消息',
        enterTimeInSeconds: '输入时间（秒）',
        enterHeight: '输入高度',
        enterWidth: '输入宽度',
        flowInitialMessage: '输入初始问题',
      },
      appTooltip: {
        standardLayout: '标准布局',
        rightLayout: '右侧布局',
        mergedLayout: '合并布局',
        enterNameOfYourBot: '输入您的机器人名称',
        enterNameOfYourLandingPageBot: '输入您的登录页面机器人名称',
        headingTextThatAppearOnLandingPageBot: '输入要显示在登录页面机器人上的标题文本',
        descriptionTextThatAppearOnLandingPageBot: '输入要显示在登录页面机器人上的描述文本',
        addLinksAndSocialMediaIcons: '添加链接和社交媒体图标',
        initialFlowMessage: '输入机器人将向客户发送以启动对话的第一条消息',
        anInvitingCatchPhrase: '一个吸引人的口号，将使用户与机器人交谈',
        setAWelcomeMessageForYourVisitors: '为您的访客设置欢迎消息。这将是对话中的第一条消息。',
        setAMessageToInitiateLiveChat: '设置启动来自访客端实时聊天的消息。每次触发此消息时，您都将收到通知。',
        autoHideCallToAction: '在指定时间后自动隐藏“呼叫动作”文本',
        TOOLTIP_HIDE_LANDINGPAGE_INFO: '您可以选择隐藏徽标和文本，只显示屏幕上的聊天窗口',
        TOOLTIP_LANDINGPAGE_PROFILE_ICON: '为聊天机器人页面上传徽标。',
        TOOLTIP_CHAT_THEME_COLOR: '选择机器人聊天窗口的颜色',
        TOOLTIP_CHAT_THEME_BACKGROUND_COLOR: '选择Bot聊天窗口的背景颜色',
        TOOLTIP_WEB_1ST_POSITION: '将机器人定位在用户桌面的左下角',
        TOOLTIP_WEB_2ND_POSITION: '将机器人定位在用户桌面的中右角',
        TOOLTIP_WEB_3RD_POSITION: '将机器人定位在用户桌面的右下角',
        TOOLTIP_MOBILE_1ST_POSITION: '将机器人定位在用户移动设备的左下角',
        TOOLTIP_MOBILE_2ND_POSITION: '将机器人定位在用户移动设备的中右角',
        TOOLTIP_MOBILE_3RD_POSITION: '将机器人定位在用户移动设备的右下角',
        TOOLTIP_WINDOW_HEIGHT: '调整机器人聊天窗口的大小',
        TOOLTIP_BOT_ICON: '为您的机器人选择图标或上传徽标/图片',
        flowTriggerMessage: '输入在收集姓名、电子邮件和电话等联系方式之前要问的消息数',
      },
    },
    dripCampaigns: {
      createDripCampaignHeader: '创建滴漏活动',
      youCanCreateMultipleCampaigns: '您可以创建多个活动',
      dripCampaignName: '滴漏活动名称',
      dripCampaignNameIsReuired: '需要滴漏活动名称',
      continue: '继续',
      manageDripCampaign: '管理滴漏活动',
      youCanCreateMultipleCampaignsWith: '您可以创建多个带有计划的滴漏活动，自动发送消息以触发特定用户组的响应。',
      createNewDripCampaign: '创建新的滴漏活动',
      campaignName: '活动名称',
      appliedOn: '应用于',
      segment: '分组',
      template: '模板',
      startDate: '开始日期',
      action: '动作',
      nA: '不适用',
      seeHowToUse: '查看如何使用',
      deleteDripCampaign: '删除滴漏活动',
      wantToDeleteThisDripCampaign: '确定要删除此滴漏活动吗？',
      placeholders: {
        enterDripCampaignName: '输入滴漏活动名称',
        searchByName: '按名称搜索',
      },
      appTooltip: {
        deleteMultipleDripCampaigns: '删除多个滴漏活动',
        deleteDripCampaign: '删除滴漏活动',
      },
      createDripCampaign: {
        dripCampaignName: '滴漏活动名称',
        appliedOn: '应用于',
        segments: '分组',
        selectDate: '选择日期',
        scheduleYourTemplate: '安排您的模板',
        schedule: '日程安排',
        template: '模板',
        sendAfter: '发送后',
        assignVariablesToTemplate: '为模板分配变量',
        addHeaderMedia: '添加标题媒体',
        selectFile: '选择文件',
        createDripCampaign: '创建滴漏活动',
        newSubscriber: '新订阅者',
        minutes: '分钟',
        hours: '小时',
        days: '天',
        placeholders: {
          enterDripName: '输入滴漏名称',
          selectAppliedOn: '选择应用于',
          selectSegments: '选择分组',
          searchByName: '按名称搜索',
          selectTemplate: '选择模板',
          searchTemplateByName: '按名称搜索模板',
          enterSendAfter: '输入发送后',
          selectValueForThisVariable: '为此变量选择值',
          searchHeaderVariableByName: '按名称搜索头变量',
          searchBodyVariableByName: '按名称搜索正文变量',
        },
        dateTimePicker: {
          selectStartDate: '选择开始日期',
        },
      },
    },
    general: {
      configureLandingPageGeneralSettings: '配置您的登录页面的常规设置',
      configureBotsGeneralSettings: '配置您的机器人的常规设置',
      selectTheTimeZone: '选择时区、语言和一小段注释，当',
      isNotAvailable: '不可用',
      landingPagesBot: '登录页面的机器人',
      bot: '机器人',
      waitingMessage: '等待消息',
      landingPageBotStatus: '登录页面机器人状态',
      chatBotStatus: '聊天机器人状态',
      unavailabilityMessage: '不可用消息',
      sendIncompleteResponses: '发送不完整的响应',
      language: '语言',
      invalidateCache: '使缓存无效',
      timezone: '时区',
      chatWindowMessageHistory: '聊天窗口消息历史',
      session: '会话',
      forever: '永远',
      english: '英语',
      spanish: '西班牙语',
      french: '法语',
      portuguese: '葡萄牙语',
      german: '德语',
      italian: '意大利语',
      swedish: '瑞典语',
      arabic: '阿拉伯语',
      malay: '马来语',
      russian: '俄语',
      discard: '丢弃',
      saveChanges: '保存更改',
      seeHowToUse: '查看如何使用',
      placeholders: {
        enterYourWaitingMessageHere: '在此输入您的等待消息',
        searchTimeZone: '搜索时区',
      },
      appTooltip: {
        TOOLTIP_WAITING_MESSAGES: '根据您希望在机器人用户发送实时聊天请求后立即在聊天窗口上显示的方式自定义消息',
        TOOLTIP_CHATBOT_STATUS: '激活/停用机器人',
        TOOLTIP_UNAVAILABILITY_MESSAGE: '根据您希望在没有任何代理可用于与机器人用户进行实时聊天时在聊天窗口上显示的方式自定义消息',
        TOOLTIP_SEND_INCOMPLETE_RESPONSES: '即使机器人用户尚未完成对话，也发送电子邮件通知。',
        TOOLTIP_LANGUAGE: '选择机器人的语言',
        TOOLTIP_INVALIDATE_CACHE: '单击此处以在编辑机器人聊天流或设置时清除缓存，因为更改只有在 15 分钟后才会反映出来',
        TOOLTIP_TIME_ZONE: '为您的机器人选择时区',
        TOOLTIP_CHAT_RETENTION: '选择是否永远在聊天窗口上保留机器人用户的聊天，还是仅在浏览器会话中保留。',
      },
    },
    liveChat: {
      customizeYourChatWindow: '定制您的聊天窗口',
      controlAndCustomizeTheChatWindow: '控制和定制您的客户将与之交互的聊天窗口。',
      allowVisitorsToTransferChatToWhatsapp: '允许访客将聊天转移到WhatsApp',
      allowVisitorsToRefreshChat: '允许访客刷新聊天',
      displayNameForTransferringChatToWhatsapp: '转移到Whatsapp的聊天显示名称',
      displayNameForTransferringToLiveChat: '转移到实时/代理聊天的显示名称',
      displayNameForTransferringAChatToBot: '转移到机器人的聊天显示名称',
      discard: '丢弃',
      saveChanges: '保存更改',
      allowVisitorsToTransferChatToBot: '允许访客将聊天转移到机器人。',
      allowVisitorsToRequestForLiveChat: '允许访客请求实时聊天。',
      indicativeTextForCustomersReply: '客户回复的指示性文本',
      displayNameForRestartingChatBot: '重新启动Chatbot会话的显示名称',
      seeHowToUse: '查看如何使用',
      placeholders: {
        enterButtonNameForWhatsapp: '输入转移到WhatsApp的按钮名称',
        enterButtonNameForLiveChat: '输入转移到实时聊天或代理的按钮名称',
        enterButtonNameForBot: '输入转移到机器人的按钮名称',
        enterTextDisplayInEmptyReplyArea: '输入在空白回复区域显示的文本',
        enterButtonForRestartingConversation: '输入重新启动对话的按钮名称',
      },
      appTooltip: {
        TOOLTIP_TRANSFER_CHAT_TO_WHATSAPP: '允许网站访客将聊天转移到WhatsApp，与他们连接的相应代理的编号。必须启用实时聊天功能才能使用此功能。',
        TOOLTIP_ALLOW_VISITOR_TO_REFRESH_CHAT: '允许机器人用户刷新聊天，以便他们可以重新开始对话。',
        TOOLTIP_ALLOW_TRANSFER_CHAT_TO_BOT: '允许机器人用户随时在与实时聊天代理对话中转移到机器人。',
        TOOLTIP_ALLOW_REQUEST_FOR_CHAT: '允许机器人用户随时向代理请求实时聊天。',
        ifYouHaveEnabledUserToTransferToWhatsapp: '如果您已启用用户转移到WhatsApp，请填写您希望显示该选项的方式',
        ifYouHaveEnabledUserToTransferToLiveChat: '如果您已启用用户转移到实时聊天，请填写您希望显示该选项的方式',
        ifYouHaveEnabledUserToTransferToWhatsapp2: '如果您已启用用户转移到WhatsApp，请填写您希望返回机器人的方式',
        howWouldYouLikeToDisplayReplySpaceForCustomers: '填写您希望为客户显示回复空间的方式',
        ifYouHaveEnabledUserToRestartChatBot: '如果您已启用用户重新启动Chatbot对话，请填写您希望显示该选项的方式',
      },
    },
    socialPlatforms: {
      chatFlowsHeader: '聊天流程',
      dripCampaignHeader: '滴灌活动',
      widgetsHeader: '小部件',
      broadcastHeader: '广播',
      ordersHeader: '订单',
      manageHeader: '管理',
      inputHeader: '输入',
      apiKeyHeader: 'API 密钥',
      appTooltip: {
        TOOLTIP_DRIP_CAMPAIGN_TITLE: '使用预定聊天流程的滴定活动创建客户入门旅程。',
        TOOLTIP_CHAT_FLOW_TITLE: '定制聊天流程模板，并为不同目标受众创建多个聊天流程。',
        TOOLTIP_WIDGET_TITLE: '创建小部件（聊天界面）并将它们嵌入促销网页，引导访问者到机器人。',
        TOOLTIP_BROADCAST_TITLE: '在预定时间一键向联系人发送消息或流程',
        TOOLTIP_ORDERS_TITLE: '客户下的订单列表',
        TOOLTIP_MANAGE_TITLE: '管理与联系人/潜在客户和关键词相关的机器人功能',
        TOOLTIP_INPUT_TITLE: '为联系人/潜在客户创建 WhatsApp 模板、图像和文本作为回复材料',
      },
      apiWrapper: {
        whatsappApiCredentials: 'WhatsApp API 凭据',
        generateYourWhatsappApiKey: '生成您的 WhatsApp API 密钥，以与您的定制开发的应用程序集成。',
        generateApiKey: '生成 API 密钥',
        webhookUrl: 'Webhook URL',
        addHeader: '添加标题',
        test: '测试',
        webhookNotSet: 'Webhook 未设置',
        webhookHeaders: 'Webhook 标头',
        setWebhookUrl: '设置 Webhook URL',
        placeholders: {
          yourApiKey: '您的 API 密钥',
          enterWebhookUrl: '输入 Webhook URL',
          enterHeaderKey: '输入标题键',
          enterValue: '输入值',
        }
      },
      broadcast: {
        createBroadcast: '创建广播',
        createMultipleBroadcasts: '您可以创建多个广播，为不同的客户群体安排多个预定的流程/模板。',
        broadcastName: '广播名称',
        nameIsRequired: '名称是必需的',
        selectType: '选择类型',
        selectYourFlowType: '选择您的流程类型',
        segment: '群体',
        selectYourSegmentType: '选择您的群体类型',
        whenToSend: '何时发送',
        selectDate: '选择日期',
        messageTag: '消息标签',
        selectMessageTag: '选择消息标签',
        contentType: '内容类型',
        nonPromotional: '非促销（应用消息标签）',
        tagEachMessgeThatComesBeforeAnyInteraction: '在任何交互或超过 24 小时的延迟步骤之后，使用适当的标签标记每条消息。未标记的消息将无法到达于 24 小时前与机器人互动的订阅者。',
        promotional: '促销（忽略消息标签）',
        theseBroadcasts: '这些广播可以包含促销内容，但目标受众仅限于在过去 24 小时内与您的机器人互动的订阅者。',
        createNewBroadcast: '创建新广播',
        sentMessages: '已发送消息',
        deliveredMessages: '已交付消息',
        readMessages: '已读消息',
        failedMessages: '发送失败消息',
        type: '类型',
        template: '模板',
        sent: '已发送',
        delivered: '已交付',
        read: '已读',
        failed: '发送失败',
        broadcastAt: '广播时间',
        status: '状态',
        shipmentUpdate: '发货更新',
        resendFailedMessages: '重新发送发送失败的消息',
        number: '号码',
        errorCode: '错误代码',
        failedAt: '发送失败于',
        badGateway: '502 错误网关',
        loadMore: '加载更多',
        placeholders: {
          enterBroadcastName: '输入广播名称',
          searchBroadcastByName: '按名称搜索广播',
        },
        appTooltip: {
          totalBroadcastMessagesSent: '总广播消息数',
          totalBroadcastMessagesDelivered: '总交付的广播消息数',
          totalBroadcastMessagesReadByContacts: '联系人已阅读的广播消息总数',
          totalFailedBroadcastMessages: '发送失败的广播消息总数',
          clickToViewDetailedInformationOfFailedMessages: '点击查看发送失败消息的详细信息',
          clickToCreateNewBroadcast: '点击创建新广播',
          templateUsedInBroadcast: '广播中使用的模板',
          numberOfBroadcastMessagesSent: '发送的广播消息数量',
          numberOfBroadcastMessagesDelivered: '交付的广播消息数量',
          numberOfBroadcastMessagesReadByContacts: '联系人已阅读的广播消息数量',
          numberOfTimesBroadcastMessagesHasFailed: '广播消息发送失败的次数',
          contactNumberOnWhichMessageDeliveryFailed: '消息发送失败的联系人号码',
          unDeliveredTemplate: '未交付的模板',
          errorReceivedForFailedMessage: '发送失败消息的错误',
          timeWhenMessageDeliveryFailed: '消息发送失败的时间',
          TOOLTIP_ADD_BROADCAST_NAME: '输入新广播名称',
          TOOLTIP_BROADCAST_SELECT_TYPE: '选择是广播流程还是消息。',
          TOOLTIP_BROADCAST_FLOW: '选择要广播的聊天流程，',
          TOOLTIP_BROADCAST_SELECT_YOUR_SEGMENT: '选择要广播的联系人群体',
          TOOLTIP_BROADCAST_NAME: '广播名称',
          TOOLTIP_BROADCAST_TYPE: '广播流程或消息的选择',
          TOOLTIP_BROADCAST_SEGMENT: '创建广播的群体',
          TOOLTIP_BROADCAST_AT: '广播计划的日期和时间',
          TOOLTIP_BROADCAST_STATUS: '广播的状态，如已计划、当前运行或已完成',
        }
      },
      drip: {
        createDripCampaign: '创建滴定活动',
        youCanCreateMultipleCampaigns: '您可以创建多个滴定活动',
        dripCampaignName: '滴定活动名称',
        dripCampaignNameIsRequired: '滴定活动名称是必需的',
        youCanCreateMultipleDripCampaigns: '您可以创建多个滴定活动，以安排定时的自动消息以触发特定用户群的响应。',
        campaignName: '活动名称',
        campaignNameIsRequired: '活动名称是必需的',
        after: '之后 ',
        thisMessageWillBeSendAfter: '此消息将在之后发送',
        saveAndUpdate: '保存和更新',
        schedule: ' 计划',
        select: '选择',
        messages: '消息',
        cancel: '取消',
        createCampaign: '创建活动',
        updateCampaign: '更新活动',
        createNewCampaign: '创建新活动',
        messagesSent: '已发送的消息',
        createdAt: '创建于',
        updatedAt: '更新于',
        action: '操作',
        placeholders: {
          nameYourDripCampaign: '给您的滴定活动命名',
          enterCampaignName: '输入活动名称',
          searchCampaignByName: '按名称搜索活动',
        },
        appTooltip: {
          TOOLTIP_CREATE_CAMPAIGN: '单击以添加新活动',
          TOOLTIP_SCHEDULE: '计划何时以及发送此活动的第一个流程。',
          TOOLTIP_AFTER_DAYS: '安排在多少分钟、小时或天内发送活动的第一个流程。',
          TOOLTIP_ADD_MESSAGES: '单击以向活动添加新流程',
          TOOLTIP_ADD_CAMPAIGN_NAME: '输入新活动名称',
          TOOLTIP_CAMPAIGN_NAME: '活动名称',
          TOOLTIP_NO_MESSAGES_SENT: '活动发送的消息数',
          TOOLTIP_CAMPAIGN_CREATED_AT: '创建活动的日期和时间',
          TOOLTIP_CAMPAIGN_UPDATED_AT: '活动上次修改的日期和时间',
          TOOLTIP_CAMPAIGN_ACTION: '编辑或删除活动',
          TOOLTIP_UPDATE_CAMPAIGN: '单击以保存对活动设置所做的修改',
        }
      },
      flows: {
        createChatFlow: '创建聊天流程',
        youCanCreateMultipleConversationsFlow: '您可以在多个渠道上创建多个对话流程，用于 A/B 测试和广播。',
        flowName: '流程名称',
        nameIsRequired: '名称是必需的',
        cancel: '取消',
        createFlow: '创建流程',
        createNewFlow: '创建新流程',
        ofMessages: '的消息',
        triggered: '触发',
        stepsFinsished: '步骤完成',
        finished: '完成',
        createdOn: '创建于',
        lastModified: '上次修改',
        defaultFlow: '默认流程',
        action: '操作',
        flowAnalytics: '流程分析',
        placeholders: {
          enterFlowName: '输入流程名称',
          searchFlowByName: '按名称搜索流程',
        },
        appTooltip: {
          numberOfTimesChatFlowTriggered: '聊天流程触发次数',
          numberOfCompletedChatFlowStepsWhenTriggered: '触发时已完成的聊天流程步骤数',
          numberOfTimesUsersCompletedChatFlowSteps: '用户完成所有聊天流程步骤的次数',
          dateAndTimeOfCreationOfChatFlow: '创建聊天流程的日期和时间',
          dateAndTimeWhenChatFlowLastModified: '聊天流程上次修改的日期和时间',
          TOOLTIP_CREATE_FLOW: '单击以创建新的聊天流程',
          TOOLTIP_FLOW_NAME: '输入聊天流程名称',
          TOOLTIP_FLOW_TABLE_NAME: '聊天流程的名称',
          TOOLTIP_NO_OF_MESSAGES: '聊天流程中的消息组件数',
          TOOLTIP_DEFAULT_FLOW: '使用此切换将聊天流程设置为默认，将提供给所有新用户。',
          TOOLTIP_ACTION: '编辑或删除聊天流程',
        }
      },
      manage: {
        leads: '线索',
        manageBotsFunctionalityForContacts: '管理对联系人/线索的机器人功能',
        whenToSendLeadInfo: '何时发送线索信息',
        smartFlow: '智能流程',
        welcomeMessageWhenNoSearchKeywordIsMet: '当未满足关键字搜索时的欢迎消息',
        selectTemplates: '选择模板',
        selectFlows: '选择流程',
        selectText: '选择文本',
        selectImages: '选择图像',
        whenItAlmostReaches24HoursSinceMessage: '当距离上次消息几乎达到24小时时',
        updateChanges: '更新更改',
        manageBotsFunctionalityAccordingToKeywords: '根据机器人用户输入的关键字管理机器人的功能，以实现智能流程',
        addKeywordAction: '添加关键字操作',
        keywords: '关键字',
        matchingMethod: '匹配方法',
        replyMaterial: '回复素材',
        action: '操作',
        select: '选择',
        placeholders: {
          keyword: '关键字'
        },
        appTooltip: {
          TOOLTIP_LEADS_WHEN_TO_SEND_LEAD: '建议机器人立即将联系人/线索信息发送到集成 CRM，或在5分钟后，或在流程结束时',
          TOOLTIP_LEAD_SMART_FLOW: '选择任何默认流程以将其发送到所有机器人用户，或智能流程（由机器人用户输入的关键字确定）。',
          TOOLTIP_LEAD_WELCOME_MESSAGE: '如果机器人从机器人用户的响应中未收到关键字匹配，则选择回复素材（流程、模板、文本、图像）发送。',
          TOOLTIP_IT_ALMOST_REACHED: '选择在联系人/线索最后一次消息的24小时之前发送的回复素材',
          TOOLTIP_KEYWORD_ACTION_TITLE: '根据机器人用户输入的关键字管理机器人的功能，以实现智能流程',
          TOOLTIP_ADD_KEYWORD_ACTIONS_HEADING: '根据特定关键字输入选择机器人的回复作为模板、流程、文本或图像',
          TOOLTIP_ADD_KEYWORD: '添加关键字',
          TOOLTIP_MATCHING_METHOD: '添加关键字匹配为“精确”或“包含”',
          TOOLTIP_REPLY_MATERIAL: '选择用于建议关键字的模板、流程、文本或图像',
          TOOLTIP_KEYWORD_ACTIONS: '删除关键字操作',
        },
        socialAlerts: {
          alerts: '警报',
          specifyHowYourBotWillNotify: '指定机器人将如何通知您有关新线索的方式。',
        }
      },
      orders: {
        manageCustomersOrder: '管理客户订单',
        checkAndManageAllOfYourCustomerOrders: '检查和管理您所有的客户订单和更新。',
        selectShipmentTemplate: '选择发货模板',
        send: '发送',
        export: '导出',
        phoneNumber: '电话号码',
        numberOfItems: '物品数量',
        orderValue: '订单价值',
        orderDate: '订单日期',
        status: '状态',
        chat: '聊天',
        item: '项目',
        quantity: '数量',
        amount: '金额',
        unitPrice: '单价',
        placeholders: {
          searchOrdersByPhoneNumber: '按电话号码搜索订单',
        },
        appTooltip: {
          exportOrdersDataInCSVFile: '以 CSV 文件导出订单数据',
          TOOLTIP_ORDERS_PHONE_NO: '下订单的客户的电话号码',
          TOOLTIP_NO_OF_ITEMS: '订购的物品数量',
          TOOLTIP_ORDER_VALUE: '订单价值',
          TOOLTIP_ORDER_DATE: '订单下达日期。',
          TOOLTIP_ORDER_STATUS: '订单状态：确认、挂起、拒绝或已发货',
          TOOLTIP_ORDER_CHAT: '有关此订单的所有先前的聊天对话',
        }
      },
      widgets: {
        installWidgetHeader: '安装小部件',
        createWidgetHeader: '创建小部件',
        copyTheCodeAndPasteItWhereYouWant: '复制代码并将其粘贴到您希望的任何位置，例如 HTML、网站等。',
        youCanCreateMultipleWidgets: '您可以创建多个小部件，使您的机器人在不同的网页上具有不同的外观。',
        installWidget: {
          javascript: 'Javascript',
          install: '安装 ',
          onYourWebsite: ' 在您的网站上',
          copyCode: '复制代码',
          copyAndPaste: '复制并粘贴',
          copyThisCodeSnippet: '复制此代码片段并将其插入到您希望显示小部件的每个网页的 HTML 中。有关更多详细信息',
          seeGuide: '请参阅指南',
        },
        widgetList: {
          widgetName: '小部件名称',
          nameIsRequired: '名称是必需的',
          cancel: '取消',
          createWidget: '创建小部件',
          icon: '图标',
          name: '名称',
          createdAt: '创建时间',
          action: '操作',
          placeholders: {
            enterWidgetName: '输入小部件名称',
            searchWidgetByName: '按名称搜索小部件',
          },
          appTooltip: {
            widgetIcon: '小部件图标',
            nameOfWidget: '小部件名称',
            dateAndTimeOfCreationOfWidget: '创建小部件的日期和时间',
            editOrDeleteWidget: '编辑或删除小部件',
          }
        },
        widgetTemplates: {
          widgetName: '小部件名称',
          nameIsRequired: '名称是必需的',
          chooseTypeOfWidget: '选择小部件的类型',
          bar: '栏',
          slideIn: '滑入',
          pageTakeOver: '页面接管',
          button: '按钮',
          facebookModal: 'Facebook 模态框',
          comment: '评论',
          direct: '直接',
          whatsappIcon: 'WhatsApp 图标',
          refUrl: '引荐网址',
          qrCode: 'QR 码',
          backgroundColor: '背景颜色',
          descriptionColor: '描述颜色',
          headlineColor: '标题颜色',
          buttonBackgroundColor: '按钮背景颜色',
          contactNumber: '联系号码',
          entryMessage: '进入消息',
          buttonText: '按钮文本',
          selectButtonText: '选择按钮文本',
          buttonSize: '按钮大小',
          selectOne: '选择一个',
          placement: '放置',
          rightBottom: '右下角',
          optInFlow: '选择流程',
          selectFlow: '选择流程',
          addSubscriberToSequence: '将订阅者添加到序列',
          selectDrip: '选择滴定',
          whenDoesItDisplay: '何时显示它（秒）',
          showWidgetToSameUserAgainAfter: '在用户手动关闭后，何时再次显示小部件',
          specificPosts: '特定帖子',
          allPosts: '所有帖子',
          postMessage: '帖子消息',
          postDate: '帖子日期',
          status: '状态',
          action: '操作',
          discard: '放弃',
          saveChanges: '保存更改',
          nextStep: '下一步',
          widgetDescription: '小部件描述',
          integrateTheBarWidget: '在您的网站正文中集成 Bar 小部件，增加您的页面订阅者，并发送他们自定义的机器人消息流。',
          hereIsYourWidgetHeadline: '这是您的小部件标题，单击此处更改它。',
          sendUsMessage: '给我们发消息',
          weAlsoPutDefaultTextHere: '我们还在这里放置默认文本。确保将其转换为有价值的消息',
          selectYourPagePost: '选择您的页面帖子',
          nA: '不适用',
          saveRule: '保存规则',
          placeholders: {
            enterWidgetName: '输入小部件名称',
            enterNumber: '输入数字',
            enterMessageHere: '在此输入消息',
            enterTimeInSeconds: '输入秒数',
          }
        }
      }
    },
    triggers: {
      customizeYourBotsTriggerSettings: `定制您的机器人触发设置`,
      makeYourBotsTimingPerfect: `使您的机器人时机完美`,
      onDesktopTriggerTime: '在桌面上触发时间（秒）',
      onMobileTriggerTime: '在移动设备上触发时间（秒）',
      chatBubble: '聊天气泡自动打开',
      seconds: '秒',
      discard: '丢弃',
      saveChanges: '保存更改',
      autoTriggerOnOrOff: '禁用自动触发',
      seeHowToUse: '查看如何使用',
      alwaysOpenAfter: '总是在上述指定的触发后打开',
      automaticallyAfterSelectedNumberOfTime: '在选择的时间后自动打开',
      neverAutomaticallyOpenBot: '永远不要自动打开机器人',
      placeholders: {
        enterTimeInSeconds: '输入时间（秒）',
      },
      appTooltip: {
        TOOLTIP_DESKTOP_TRIGGER_TIME: '在访问者桌面设备上等待的时间（秒），然后您的机器人将自动弹出',
        TOOLTIP_MOBILE_TRIGGER_TIME: '在访问者移动设备上等待的时间（秒），然后您的机器人将自动弹出',
        TOOLTIP_CHAT_BUBBLE_OPENING: '当访客关闭聊天窗口时，选择机器人的自动弹出行为',
        customerWaitingTimeToOpenBubble: '客户等待时间以打开聊天气泡',
        wantToDisableAutoTriggering: '如果您不希望在网站上自动打开聊天机器人，请启用此选项',
      }
    },
    userAccess: {
      customizeYourBotsSettings: `定制您的机器人用户设置`,
      decideWhoCanAccessYourBot: '决定谁能访问您的机器人',
      deviceSupport: '设备支持',
      blockIpAddresses: '阻止 IP 地址',
      hideChatBotOnSpecificPages: '在特定页面上隐藏聊天机器人',
      selectCountriesToEnableBot: '选择启用机器人的国家',
      discard: '丢弃',
      saveChanges: '保存更改',
      seeHowToUse: '查看如何使用',
      allDevices: '所有设备',
      mobileOnly: '仅限移动设备',
      desktopOnly: '仅限桌面设备',
      placeholders: {
        enterIpAddress: `输入 IP 地址（IPv4 或 IPv6）然后按 'Enter'`,
        enterUrl: `输入页面的 URL，然后按 'Enter'`,
        searchCountry: '搜索国家',
      },
      appTooltip: {
        TOOLTIP_DEVICE_SUPPORT: '选择机器人应该出现在哪些设备上',
        TOOLTIP_BLOCK_IP_ADDRESS: '输入您不希望机器人出现的 IP 地址',
        TOOLTIP_HIDE_CHATBOT_SPECIFIC_PAGES: '输入您不希望机器人出现的网页的 URL',
        TOOLTIP_COUNTRIES_TO_ENABLE_BOT: '选择希望用户从中访问机器人的位置',
      }
    },
    facebook: {
      facebookBotSettings: 'Facebook 机器人设置',
      chatFlowsHeader: '聊天流程',
      dripCampaignHeader: '滴灌活动',
      broadcastHeader: '广播',
      widgetsHeader: '小部件',
      autoReplyHeader: '自动回复',
      generalHeader: '一般',
      facebookAutomation: 'Facebook 自动化',
      appTooltip: {
        TOOLTIP_CHAT_FLOW_TITLE: '定制聊天流程模板，并为不同的目标受众创建多个聊天流程。',
        TOOLTIP_DRIP_CAMPAIGN_TITLE: '使用预定的聊天流程创建客户入职旅程的滴定活动。',
      },
      broadcasts: {
        createBroadcast: '创建广播',
        youCanCreateMultipleBroadcasts: '您可以创建多个广播',
        broadcastName: '广播名称',
        broadcastNameIsRequired: '广播名称是必需的',
        continue: '继续',
        manageBroadcasts: '管理广播',
        youCanCreateMultipleBroadcastsWith: '您可以为不同的客户群体创建多个预定模板的广播。',
        createNewBroadcast: '创建新的广播',
        name: '名称',
        segment: '群组',
        template: '模板',
        contacts: '联系人',
        send: '发送',
        failed: '失败',
        broadcastAt: '广播时间',
        status: '状态',
        actions: '操作',
        nA: 'N/A',
        deleteBroadcast: '删除广播',
        wantToDeleteThisBroadcast: '您确定要删除此广播吗？',
        placeholders: {
          enterBroadcastName: '输入广播名称',
          searchHere: '在此搜索',
        },
        appTooltip: {
          deleteMultipleBroadcasts: '删除多个广播',
          deleteBroadcast: '删除广播',
        }
      },
      createBroadcastFacebook: {
        braodcastName: '广播名称',
        broadcastNameIsRequired: '广播名称是必需的',
        flow: '流程',
        segments: '群组',
        whenToSend: '何时发送',
        selectDate: '选择日期',
        selectTimeSlot: '选择时间段',
        createBroadcast: '创建广播',
        cancel: '取消',
        now: '现在',
        later: '稍后',
        placeholders: {
          enterBroadcastName: '输入广播名称',
          selectFlow: '选择流程',
          searchFlowByName: '按名称搜索流程',
          selectSegments: '选择群组',
          searchSegmentByName: '按名称搜索群组',
          selectTimeSlot: '选择时间段',
        },
        indexMergeDatePicker: {
          selectStartDate: '选择开始日期',
        }
      },
      dripCampaigns: {
        createDripCampaign: '创建滴定活动',
        youCanCreateMultipleCampaign: '您可以创建多个活动',
        dripCampaignName: '滴定活动名称',
        dripCampaignNameIsRequired: '滴定活动名称是必需的',
        continue: '继续',
        manageDripCampaign: '管理滴定活动',
        youCanCreateMutlipleDripCampaign: '您可以创建多个预定模板的广播，以计划、自动发送消息，以触发特定用户组的响应。',
        createNewDripCampaign: '创建新的滴定活动',
        campaignName: '活动名称',
        appliedOn: '应用于',
        segment: '群组',
        flow: '流程',
        startDate: '开始日期',
        action: '操作',
        nA: 'N/A',
        deleteDripCampaign: '删除滴定活动',
        wantToDeleteThisDripCampaign: '您确定要删除此滴定活动吗？',
        placeholders: {
          enterDripCampaignName: '输入滴定活动名称',
          searchByName: '按名称搜索',
        },
        appTooltip: {
          deleteMultipleDripCampaigns: '删除多个滴定活动',
          deleteDripCampaign: '删除滴定活动',
        },
        createDripCampaignFacebook: {
          dripCampaignName: '滴定活动名称',
          appliedOn: '应用于',
          segments: '群组',
          selectDate: '选择日期',
          scheduleYourFlows: '安排您的流程',
          schedule: '时间表',
          flow: '流程',
          sendAfter: '发送后',
          cancel: '取消',
          newSubscriber: '新订阅者',
          days: '天',
          minutes: '分钟',
          hours: '小时',
          createDripCampaign: '创建滴定活动',
          placeholders: {
            enterDripName: '输入滴定名称',
            selectAppliedOn: '选择应用于',
            selectSegment: '选择群组',
            searchByName: '按名称搜索',
            selectTemplate: '选择模板',
            searchFlowByName: '按名称搜索流程',
            enterSendAfter: '输入发送后',
          },
          dateTimePicker: {
            selectStartDate: '选择开始日期',
          }
        }
      },
      failedBroadcastFacebook: {
        chatId: '聊天 ID',
        errorCode: '错误代码',
        errorMessage: '错误消息',
        nA: 'N/A',
      },
      flows: {
        chatFlows: '聊天流程',
        createChatFlow: '创建聊天流程',
        youCanCreateMultipleChatFlows: '您可以为 A/B 测试和广播创建多个跨多个渠道的对话流程。',
        flowName: '流程名称',
        nameIsRequired: '名称是必需的',
        cancel: '取消',
        createFlow: '创建流程',
        importFlow: '导入流程',
        createNewFlow: '创建新流程',
        ofMessages: '消息',
        createdOn: '创建于',
        lastModified: '上次修改',
        defaultFlow: '默认流程',
        action: '操作',
        exportStatus: '导出状态',
        flowExport: '流程导出',
        download: '下载',
        beforeYouStartUploadPleaseMakeSure: '开始上传之前，请确保',
        point1: '1. 最大文件大小上传限制为 20MB',
        point2: '2. 文件格式应为 JSON',
        selectFile: '选择文件',
        inProgress: '进行中',
        available: '可用',
        initiated: '已启动',
        placeholders: {
          enterFlowName: '输入流程名称',
        },
        appTooltip: {
          importFlowForFacebookBot: '导入 Facebook 机器人的流程',
          dateAndTimeOfCreationOfChatFlow: '聊天流程创建的日期和时间',
          dateAndTimeWhenChatFlowLastModified: '聊天流程上次修改的日期和时间',
          TOOLTIP_CREATE_FLOW: '单击创建新的聊天流程',
          TOOLTIP_FLOW_NAME: '输入聊天流程名称',
          TOOLTIP_FLOW_TABLE_NAME: '聊天流程的名称',
          TOOLTIP_NO_OF_MESSAGES: '聊天流程中的消息组件数量',
          TOOLTIP_DEFAULT_FLOW: '使用此切换将聊天流程设置为默认值，该流程将提供给所有新用户。',
          TOOLTIP_ACTION: '编辑或删除聊天流程',
        },
        noDataFound: {
          flows: '流程',
          noFlowsAddedYet: '尚未添加流程！',
        },
        modal: {
          deleteFlow: '删除流程',
          wantToDeleteThisFlow: '您确定要删除此流程吗？',
        }
      },
      widgets: {
        manageWidgets: '管理小部件',
        widgetsAreRoutingTools: '小部件是增加机器人使用的路由工具',
        needHelp: '需要帮助？',
        wantToMakeChanges: '想要进行更改？',
        editIcon: '编辑图标',
        discard: '放弃',
        updateWidget: '更新小部件',
        installChatBotIconOnYourWebsite: '在您的网站上安装聊天机器人图标',
        shareWhereEverYouWantToRedirectUsersTo: '在任何您想要共享并将用户重定向到的地方分享',
        copyAndAddInYourWebsiteHeaderFile: '复制并添加到您的网站页眉文件',
        copyLinkAndStartSharing: '复制链接并开始分享！',
        downloadQrCodeAndStartSharing: '下载 QR 码并开始分享！',
        addCodeAndDeployNewCodeAndDone: '添加代码、部署新代码并完成！',
        wantToLearnHowToUseIt: '想要了解如何使用吗？',
        copyChatBotCode: '复制机器人代码',
        copyFacebookLink: '复制 Facebook 链接',
        downloadQrCode: '下载 QR 码',
        link: '链接',
        chatBotIcon: '聊天机器人图标',
        qrcode: 'QR 码',
        small: '小',
        medium: '中',
        large: '大',
        leftMiddle: '左中',
        rightMiddle: '右中',
        leftBottom: '左下角',
        rightBottom: '右下角',
        bpDropDown: {
          selectIcons: '选择图标',
          iconSize: '图标大小',
          iconPlacement: '图标放置',
        }
      },
      autoReply: {
        autoReplyTitle: '自动回复',
        configureYour: '配置您的',
        message: '消息',
        customizeAutoReplyMessagesForYourPostsComments: '自定义您的帖子评论的自动回复消息',
        wouldYouLikeToApply: '您想应用',
        autoreply: '自动回复',
        onAllPost: '在所有帖子上',
        configureYourMessageForEachPost: '为每个帖子配置您的消息',
        configureFlowToTriggerAfterOnReply: '在回复后配置触发流',
        whenUserLeavesACommentSendMessageAfter: '当用户留下评论后，发送消息',
        triggerFlowOnReply: '在回复时触发流',
        add: '添加',
        update: '更新',
        save: '保存',
        cancel: '取消',
        discard: '放弃',
        bpDropDown: {
          selectPost: '选择帖子',
          triggerFlowOnReply: '在回复时触发流',
          immendiately: '立即',
          minutes: '分钟'
        },
        bpTable: {
          message: '消息',
          selectedPost: '已选帖子',
          triggerFlow: '触发流',
          actions: '操作'
        },
        placeholder: {
          configureYourMessage: '配置您的消息'
        },
        deleteModel: {
          title: '删除帖子自动回复',
          description: '您确定要删除此帖子自动回复吗？'
        }
      },
      generalSetting: {
        sendInactivityMessage: '用户不活动消息',
        sessionTimeOutInHours: '会话超时',
        enterSessionTimeOutWindowInHours: '输入会话超时窗口时间（小时）',
        sessionTimeOutInHoursTooltip: `输入持续时间，之后聊天会话将由于不活动而自动超时。
         如果用户在会话超时后发送任何消息，Chatflow 将重新启动`,
        restartChatFlowTriggers: '重新启动聊天流触发器',
        enterKeyWordsToRestartChatAndhitEnter: '输入重新启动聊天的关键字，然后按 Enter',
        restartChatFlowTriggersTooltip: `在此处指定关键字，当用户输入并提交后，将触发聊天流的重新启动。这允许用户在任何时候重新启动对话流。
        添加每个关键字后按 Enter 以添加多个关键字。`,
        liveChatTriggers: '实时聊天触发器',
        enterKeyWordsToTriggerLiveChatAndhitEnter: '输入触发实时聊天的关键字，然后按 Enter',
        liveChatTriggersTooltip: `定义关键字，当用户输入并提交后，将启动从自动聊天到实时聊天的过渡。当用户需要与实时代理交流时，这很有用。
        添加每个关键字后按 Enter 以添加多个关键字。`,
        messageAfterAutomatedFlowCompleted: '自动流程完成后的消息',
        enterYourMessage: '输入您的消息',
        messageAfterAutomatedFlowCompletedTooltip: `输入用户在完成自动聊天流程但会话未超时时将显示给用户的消息。`,
        restart: '重新启动',
        liveChat: '实时聊天',
        lineOneForDefaultMessage: '如果您有更多问题或需要帮助，以下是您可以接下来的操作：',
        to: '至',
        restartTheChat: '重新启动聊天',
        simpleTypeRestartAndHitEnter: `只需键入 '重新启动' 然后按 Enter。这将带您回到我们对话流的开头。`,
        lineThreeForDefaultMessagePartOne: `如果您想与`,
        liveAgent: `实时代理`,
        lineThreeForDefaultMessageLastPart: `交谈，请键入 '实时聊天' 然后按 Enter。我们的团队将随时为您提供帮助。`,
        saveChanges: '保存更改',
        discard: '放弃',
        configureBotsGeneralSettings: `配置您的机器人的常规设置`,
        minutes: '分钟',
        hours: '小时',
      }
    },
    instagram: {
      instagramBotSettings: 'Instagram 机器人设置',
      chatFlowsHeader: '聊天流',
      broadcastHeader: '广播',
      dripCampaignHeader: '定时发送活动',
      widgetsHeader: '小部件',
      alertsHeader: '警报',
      alerts: {
        configureYourBotsSettings: '配置机器人的警报设置',
        specifyHowYourBotNotifyYou: '指定机器人如何通知您有关新线索的信息。',
        subject: '主题',
        emailNotification: '电子邮件通知',
        emailAddresses: '电子邮件地址',
        leadRevisitNotifications: '线索再访通知',
        whenToSendLeadInfo: '何时发送线索信息',
        discard: '放弃',
        saveChanges: '保存更改',
        placeholders: {
          enterSubjectForYourEmail: '输入电子邮件主题',
          typeYourEmailAddressAndHitEnter: '输入您的电子邮件地址并按 Enter 键',
        }
      },
      broadcasts: {
        createBroadcast: '创建广播',
        youCanCreateMultipleBroadcasts: '您可以创建多个广播',
        broadcastName: '广播名称',
        broadcastNameIsRequired: '广播名称是必需的',
        continue: '继续',
        manageBroadcasts: '管理广播',
        youCanCreateMultipleBroadcastsWithMultipleTemplatesAndDifferentSegments: '您可以为不同的客户群体创建多个广播，其中包含多个计划的模板。',
        createNewBroadcast: '创建新广播',
        segment: '组',
        template: '模板',
        contacts: '联系人',
        send: '发送',
        failed: '失败',
        broadcastAt: '广播时间',
        status: '状态',
        actions: '操作',
        nA: 'NA',
        placeholders: {
          enterBroadcastName: '输入广播名称',
          searchHere: '在此搜索',
        },
        appTooltip: {
          deleteMultipleBroadcasts: '删除多个广播',
          deleteBroadcast: '删除广播',
        }
      },
      createBroadcast: {
        broadcastName: '广播名称',
        broadcastNameIsRequired: '广播名称是必需的',
        flow: '流',
        segments: '组',
        whenToSend: '何时发送',
        selectDate: '选择日期',
        selectTimeSlot: '选择时间段',
        cancel: '取消',
        createBroadcast: '创建广播',
        placeholders: {
          enterBroadcastName: '输入广播名称',
          selectFlow: '选择流',
          searchFlowByName: '按名称搜索流',
          selectSegments: '选择组',
          searchSegmentByName: '按名称搜索组',
          selectTimeSlot: '选择时间段',
        },
        indexMergeDatePicker: {
          selectStartDate: '选择开始日期',
        }
      },
      dripCampaigns: {
        createDripCampaign: '创建定时发送活动',
        youCanCreateMultipleCampaigns: '您可以创建多个定时发送活动',
        dripCampaignName: '定时发送活动名称',
        dripCampaignNameIsRequired: '定时发送活动名称是必需的',
        continue: '继续',
        manageDripCampaign: '管理定时发送活动',
        youCanCreateMultipleCampaignsWith: '您可以创建多个定时发送活动，并安排自动消息以触发特定用户组的响应。',
        createNewDripCampaign: '创建新的定时发送活动',
        campaignName: '活动名称',
        appliedOn: '应用于',
        segment: '组',
        flow: '流',
        startDate: '开始日期',
        action: '操作',
        nA: 'NA',
        placeholders: {
          enterDripCampaignName: '输入定时发送活动名称',
          searchByName: '按名称搜索',
        },
        appTooltip: {
          deleteMultipleDripCampaigns: '删除多个定时发送活动',
          deleteDripCampaign: '删除定时发送活动',
        },
        createDripCampaignInstagram: {
          dripCampaignName: '定时发送活动名称',
          appliedOn: '应用于',
          segments: '组',
          selectDate: '选择日期',
          scheduleYourFlows: '安排您的流程',
          flow: '流',
          sendAfter: '发送后',
          cancel: '取消',
          createDripCampaign: '创建定时发送活动',
          placeholders: {
            enterDripName: '输入定时发送活动名称',
            selectAppliedOn: '选择应用于',
            selectSegment: '选择组',
            searchByName: '按名称搜索',
            selectTemplate: '选择模板',
            searchFlowByName: '按名称搜索流',
            enterSendAfter: '输入发送后',
          },
          dateTimePicker: {
            selectStartDate: '选择开始日期',
          }
        }
      },
      failedBroadcastInstagram: {
        chatId: '聊天 ID',
        errorCode: '错误代码',
        errorMessage: '错误消息',
        nA: 'NA',
      },
      flows: {
        chatFlows: '聊天流',
        createChatFlow: '创建聊天流',
        youCanCreateMultipleChatFlows: '您可以在多个渠道上创建多个对话流，用于 A/B 测试和广播。',
        flowName: '流名称',
        nameIsRequired: '名称是必需的',
        cancel: '取消',
        createFlow: '创建流',
        importFlow: '导入流',
        createNewFlow: '创建新流',
        ofMessages: ' 条消息',
        createdOn: '创建于',
        lastModified: '上次修改',
        defaultFlow: '默认流',
        action: '操作',
        exportStatus: '导出状态',
        flowExport: '流导出 ',
        download: '下载',
        beforeYouStartUploadPleaseMakeSure: '开始上传前，请确保',
        point1: '1. 上传的文件最大大小限制为 20MB',
        point2: '2. 文件格式应为 JSON',
        selectFile: '选择文件',
        placeholders: {
          enterFlowName: '输入流名称',
        },
        appTooltip: {
          importFlowForInstagramBot: '导入 Instagram 机器人流',
          dateAndTimeOfCreationOfChatFlow: '聊天流创建的日期和时间',
          dateAndTimeWhenChatFlowLastModified: '聊天流上次修改的日期和时间',
        },
        noDataFound: {
          flows: '流',
          noFlowsAddedYet: '尚未添加流！',
        },
        modal: {
          deleteFlow: '删除流',
          wantToDeleteThisFlow: '确定要删除此流吗？',
        }
      },
      widgets: {
        manageWidgets: '管理小部件',
        widgetsAreRoutingTools: '小部件是增加机器人使用的路由工具',
        needHelp: '需要帮助？',
        wantToMakeChanges: '想要进行更改？',
        editIcon: '编辑图标',
        discard: '放弃',
        updateWidget: '更新小部件',
        bpDropDown: {
          selectIcons: '选择图标',
          iconSize: '图标大小',
          iconPlacement: '图标放置',
        }
      }
    },
    telegram: {
      telegramBotSettings: 'Telegram 机器人设置',
      chatFlowsHeader: '聊天流程',
      telegramProfileHeader: 'Telegram 个人资料',
      widgetsHeader: '小部件',
      broadcastHeader: '广播',
      dripCampaignHeader: '滴定广告',
      generalHeader: '常规',
      telegramAutomation: 'Telegram 自动化',
      appTooltip: {
        TOOLTIP_DRIP_CAMPAIGN_TITLE: '使用预定的聊天流程滴定广告创建客户入门旅程。',
        TOOLTIP_CHAT_FLOW_TITLE: '定制聊天流程模板，为不同目标受众创建多个聊天流程。',
      },
      broadcasts: {
        createBroadcast: '创建广播',
        youCanCreateMutlipleBroadcasts: '您可以创建多个广播',
        broadcastName: '广播名称',
        broadcastNameIsRequired: '广播名称是必需的',
        continue: '继续',
        manageBroadcasts: '管理广播',
        youCanCreateMultipleBroadcastsWith: '您可以创建多个广播，其中包含多个计划的模板，面向不同的客户群体。',
        createNewBroadcast: '创建新广播',
        name: '名称',
        segment: '组',
        template: '模板',
        contacts: '联系人',
        send: '发送',
        failed: '失败',
        broadcastAt: '广播时间',
        status: '状态',
        actions: '操作',
        nA: 'N/A',
        deleteBroadcast: '删除广播',
        wantToDeleteThisBroadcast: '您确定要删除此广播吗？',
        placeholders: {
          enterBroadcastName: '输入广播名称',
          searchHere: '在此处搜索',
        },
        appTooltip: {
          deleteMultipleBroadcasts: '删除多个广播',
          deleteBroadcast: '删除广播',
        },
      },
      createBroadcastTelegram: {
        broadcastName: '广播名称',
        broadcastNameIsRequired: '广播名称是必需的',
        flow: '流程',
        segments: '群组',
        whenToSend: '何时发送',
        selectDate: '选择日期',
        selectTimeSlot: '选择时间段',
        cancel: '取消',
        createBroadcast: '创建广播',
        now: '立即',
        later: '稍后',
        placeholders: {
          enterBroadcastName: '输入广播名称',
          selectFlow: '选择流程',
          searchFlowByName: '按名称搜索流程',
          selectSegments: '选择群组',
          searchSegmentByName: '按名称搜索群组',
          selectTimeSlot: '选择时间段',
        },
        indexMergeDatePicker: {
          selectStartDate: '选择开始日期',
        }
      },
      dripCampaigns: {
        createDripCampaign: '创建滴定广告',
        youCanCreateMultipleCampaigns: '您可以创建多个广告系列',
        dripCampaignName: '滴定广告名称',
        dripCampaignNameIsRequired: '滴定广告名称是必需的',
        continue: '继续',
        manageDripCampaign: '管理滴定广告',
        youCanCreateMultipleDripCampaignsWith: '您可以创建多个预定的、自动化的消息的滴定广告，以触发特定用户群体的响应。',
        createNewDripCampaign: '创建新的滴定广告',
        campaignName: '系列名称',
        appliedOn: '应用于',
        segment: '群组',
        flow: '流程',
        startDate: '开始日期',
        action: '操作',
        nA: 'N/A',
        deleteDripCampaign: '删除滴定广告',
        wantToDeleteThisDripCampaign: '您确定要删除此滴定广告吗？',
        placeholders: {
          enterDripCampaignName: '输入滴定广告名称',
          searchByName: '按名称搜索',
        },
        appTooltip: {
          deleteMultipleDripCampaigns: '删除多个滴定广告',
          deleteDripCampaign: '删除滴定广告',
        },
        createDripCampaignTelegram: {
          dripCampaignName: '滴定广告名称',
          appliedOn: '应用于',
          segments: '群组',
          startDate: '选择日期',
          scheduleYourFlows: '安排您的流程',
          schedule: '安排',
          flow: '流程',
          sendAfter: '发送后',
          cancel: '取消',
          createDripCampaign: '创建滴定广告',
          newSubscriber: '新订阅者',
          days: '天',
          minutes: '分钟',
          hours: '小时',
          placeholders: {
            enterDripName: '输入滴定名称',
            selectAppliedOn: '选择应用于',
            selectSegment: '选择群组',
            searchByName: '按名称搜索',
            selectFlow: '选择流程',
            searchFlowByName: '按名称搜索流程',
          },
          dateTimePicker: {
            selectStartDate: '选择开始日期',
          }
        }
      },
      failedBroadcastTelegram: {
        name: '名称',
        email: '电子邮件',
        phone: '电话',
        errorCode: '错误代码',
        errorMessage: '错误消息',
        nA: 'N/A',
      },
      flows: {
        chatFlows: '聊天流程',
        createChatFlow: '创建聊天流程',
        youCanCreateMultipleChatFlows: '您可以创建多个跨多个渠道进行A/B测试和广播的会话流程。',
        flowName: '流程名称',
        nameIsRequired: '名称是必需的',
        cancel: '取消',
        createFlow: '创建流程',
        importFlow: '导入流程',
        createNewFlow: '创建新流程',
        ofMessages: ' 条消息',
        createdOn: '创建于',
        lastModified: '上次修改',
        defaultFlow: '默认流程',
        action: '操作',
        exportStatus: '导出状态',
        flowExport: '流程导出',
        inProgress: '进行中',
        available: '可用',
        initiated: '已启动',
        download: '下载',
        beforeYouStartUploadPleaseMakeSure: '在开始上传之前，请确保',
        point1: '1. 文件大小上传限制为20MB',
        point2: '2. 文件格式应为JSON',
        selectFile: '选择文件',
        placeholders: {
          enterFlowName: '输入流程名称',
        },
        appTooltip: {
          importFlowForTelegramBot: '为Telegram机器人导入流程',
          dateAndTimeOfCreationOfChatFlow: '聊天流程创建的日期和时间',
          dateAndTimeWhenChatFlowLastModified: '聊天流程上次修改的日期和时间',
          TOOLTIP_CREATE_FLOW: '单击创建新的聊天流程',
          TOOLTIP_FLOW_NAME: '输入聊天流程名称',
          TOOLTIP_FLOW_TABLE_NAME: '聊天流程的名称',
          TOOLTIP_NO_OF_MESSAGES: '聊天流程中的消息组件数量',
          TOOLTIP_DEFAULT_FLOW: '使用此切换将聊天流程设置为默认值，该流程将提供给所有新用户。',
          TOOLTIP_ACTION: '编辑或删除聊天流程',
        },
        noDataFound: {
          flows: '流程',
          noFlowsAddedYet: '尚未添加任何流程！',
        },
        modal: {
          deleteFlow: '删除流程',
          wantToDeleteThisFlow: '您确定要删除此流程吗？',
        }
      },
      telegramProfile: {
        telegramProfile: 'Telegram个人资料',
        manageYourBotProfile: '随时管理您的机器人个人资料。',
        allSetNoActionRequired: '一切设置完毕，无需操作！',
        congratulationYourAccountIsLive: '恭喜！您的帐户已上线，具有完全访问权限',
        botDetails: '机器人详情',
        name: '名称',
        nA: 'N/A',
        b: 'B',
        botName: '机器人名称',
        bot: '机器人',
        info: '信息',
        none: '无',
        username: '用户名',
        notifications: '通知',
        on: '开',
        addToGroupOrChannel: '添加到组或频道',
        userName: '用户名',
        botToken: '机器人令牌',
      },
      widgets: {
        manageWidgets: '管理小部件',
        widgetsAreRoutingTools: '小部件是增加机器人使用的路由工具',
        needHelp: '需要帮助？',
        wantToMakeChanges: '想要进行更改？',
        editIcon: '编辑图标',
        discard: '丢弃',
        updateWidget: '更新小部件',
        installChatBotIconOnYourWebsite: '在您的网站上安装聊天机器人图标',
        shareWhereEverYouWantRedirectUsersTo: '在任何地方分享并将用户重定向到Telegram机器人',
        copyAndAddInYourWebsiteHeaderFile: '复制并添加到您的网站页眉文件中',
        copyLinkAndStartSharing: '复制链接并开始分享！',
        downloadQrCodeAndStartSharing: '下载QR码并开始分享！',
        addCodeAndDeployNewCodeAndDone: '添加代码，部署新代码，完成！',
        wantToLearnHowToUseIt: '想要了解如何使用吗？',
        copyChatBotCode: '复制聊天机器人代码',
        downloadQrCode: '下载QR码',
        copyTelegramLink: '复制Telegram链接',
        link: '链接',
        chatBotIcon: '聊天机器人图标',
        qrcode: 'QR码',
        small: '小',
        medium: '中',
        large: '大',
        leftMiddle: '左中',
        rightMiddle: '右中',
        leftBottom: '左下',
        rightBottom: '右下',
        bpDropDown: {
          selectIcons: '选择图标',
          iconSize: '图标大小',
          iconPlacement: '图标位置',
        }
      },
      generalSetting: {
        sendInactivityMessage: '用户不活动消息',
        sessionTimeOutInHours: '会话超时',
        enterSessionTimeOutWindowInHours: '输入会话超时窗口时间（小时）',
        sessionTimeOutInHoursTooltip: `输入聊天会话因不活动而自动超时的时长。
          如果用户在会话超时后发送任何消息，Chatflow 将重新启动`,
        restartChatFlowTriggers: '重新启动聊天流触发器',
        enterKeyWordsToRestartChatAndhitEnter: '输入重新启动聊天的关键词并按 Enter 键',
        restartChatFlowTriggersTooltip: `在此指定关键词，用户输入并提交后，将触发聊天流的重新启动。
          在添加每个关键词后按 Enter 键，以添加多个关键词。`,
        liveChatTriggers: '实时聊天触发器',
        enterKeyWordsToTriggerLiveChatAndhitEnter: '输入触发实时聊天的关键词并按 Enter 键',
        liveChatTriggersTooltip: `定义关键词，用户输入并提交后，将从自动聊天过渡到实时聊天。
          在添加每个关键词后按 Enter 键，以添加多个关键词。`,
        messageAfterAutomatedFlowCompleted: '自动流程完成后的消息',
        enterYourMessage: '输入您的消息',
        messageAfterAutomatedFlowCompletedTooltip: `输入用户完成自动聊天流程后显示给用户的消息，但会话尚未超时。`,
        restart: '重新开始',
        liveChat: '实时聊天',
        lineOneForDefaultMessage: '如果您有更多问题或需要帮助，下面是您可以采取的步骤：',
        to: '至',
        restartTheChat: '重新开始聊天',
        simpleTypeRestartAndHitEnter: `只需键入 '重新开始' 然后按 Enter 键。这将带您回到我们的对话流的开头。`,
        lineThreeForDefaultMessagePartOne: '如果您想与',
        liveAgent: '实时代理',
        lineThreeForDefaultMessageLastPart: '交谈，键入“实时聊天”然后按 Enter 键。我们的团队将实时为您提供帮助。',
        saveChanges: '保存更改',
        discard: '放弃',
        configureBotsGeneralSettings: '配置您的机器人的常规设置',
        minutes: '分钟',
        hours: '小时',
      },
    },
    whatsapp: {
      whatsappAutomation: 'WhatsApp自动化',
      whatsappBotSettings: 'WhatsApp Bot设置',
      generalHeader: '通用',
      chatFlowsHeader: '聊天流程',
      whatsappProfileHeader: 'WhatsApp个人资料',
      broadcastHeader: '广播',
      dripCampaignHeader: '定时发送广告',
      widgetHeader: '小部件',
      templatesHeader: '模板',
      alertsHeader: '提醒',
      apiKeyHeader: 'API密钥',
      catalogHeader: '目录',
      otherConfiguration: 'AI设置',
      appTooltip: {
        TOOLTIP_CHAT_FLOW_TITLE: '自定义聊天流程模板，并为不同目标受众创建多个聊天流程。',
      },
      alerts: {
        configureYourBotsAlertSettings: `配置您的机器人的提醒设置`,
        specifyHowYouBotWillNotify: '指定机器人如何通知您有关新线索的信息。',
        subject: '主题',
        emailNotification: '电子邮件通知',
        emailAddresses: '电子邮件地址',
        leadRevisitNotifications: '线索再访通知',
        whenToSendLeadInfo: '何时发送线索信息',
        discard: '丢弃',
        saveChanges: '保存更改',
        seeHowToUse: '查看如何使用',
        beginningTheFlow: '开始流程',
        fiveMinutesLater: '5分钟后',
        endOfFlow: '流程结束',
        placeholders: {
          enterSubjectForYourEmail: '输入电子邮件主题',
          typeEmailAndHitEnter: '输入您的电子邮件地址，然后按Enter键',
        },
        appTooltip: {
          TOOLTIP_SUBJECTS: '定制电子邮件通知的主题',
          TOOLTIP_EMAIL_NOTIFICATION: '启用/禁用有关新线索的电子邮件通知',
          TOOLTIP_EMAIL_ADDRESS: '提交希望接收电子邮件通知的帐户的电子邮件地址。您可以通过输入一个并按Enter键添加另一个来添加多个电子邮件地址。',
          TOOLTIP_LEAD_REVISIT_NOTIFICATION: '如果之前被捕获为潜在客户的用户再次与机器人互动，则启用/禁用有关电子邮件的机器人通知。',
        }
      },
      editProfile: {
        updateWhatsappChatBot: '更新WhatsApp Chatbot',
        businessNameIsRequired: '需要业务名称。',
        maxLengthForBusinessName40Characters: '业务名称的最大长度为40个字符。',
        categoryIsRequired: '需要类别。',
        descriptionIsRequired: '需要描述。',
        maxLengthForDescription200Characters: '描述的最大长度为200个字符。',
        aboutIsRequired: '需要关于。',
        maxLengthForAbout139Characters: '关于的最大长度为139个字符。',
        pleaseFillAValidBusinessEmail: '请填写有效的业务电子邮件。',
        businessEmailIsRequired: '需要业务电子邮件。',
        websiteIsRequired: '需要网站。',
        maxLengthForWebsite40Characters: '网站的最大长度为40个字符。',
        maxLengthForAddress150Characters: '地址的最大长度为150个字符。',
        cancel: '取消',
        update: '更新',
        businessCategory: '业务类别',
        placeholders: {
          yourBusinessName: '您的业务名称',
          businessDescription: '业务描述',
          about: '关于',
          businessEmail: '业务电子邮件',
          website: '网站（例如 www.example.com）',
          address: '地址',
        }
      },
      flows: {
        chatFlows: '聊天流程',
        createChatFlow: '创建聊天流程',
        youCanCreateMultipleChatFlows: '您可以在多个渠道上创建多个会话流程，进行A/B测试和广播。',
        flowName: '流程名称',
        nameIsRequired: '需要名称',
        cancel: '取消',
        createFlow: '创建流程',
        importFlow: '导入流程',
        createNewFlow: '创建新流程',
        ofMessages: ' 条消息',
        createdOn: '创建于',
        lastModified: '上次修改',
        defaultFlow: '默认流程',
        revisitFlow: '再次访问流程',
        action: '操作',
        exportStatus: '导出状态',
        flowExport: '流程导出 ',
        beforeYouStartUploadPleaseMakeSure: '在开始上传之前，请确保',
        point1: '1. 上传文件大小限制为20MB',
        point2: '2. 文件格式应为JSON',
        selectFile: '选择文件',
        seeHowToUse: '查看如何使用',
        download: '下载',
        available: '可用',
        initiated: '启动',
        inProgress: '进行中',
        placeholders: {
          enterFlowName: '输入流程名称',
        },
        appTooltip: {
          importFlowForWhatsappBot: '为WhatsApp机器人导入流程',
          dateAndTimeOfCreationOfChatFlow: '创建聊天流程的日期和时间',
          dateAndTimeWhenChatFlowLastModified: '聊天流程上次修改的日期和时间',
          TOOLTIP_CREATE_FLOW: '单击创建新的聊天流程',
          TOOLTIP_FLOW_NAME: '输入聊天流程名称',
          TOOLTIP_FLOW_TABLE_NAME: '聊天流程的名称',
          TOOLTIP_NO_OF_MESSAGES: '聊天流程中的消息组件数量',
          TOOLTIP_DEFAULT_FLOW: '使用此切换将聊天流程设置为默认值，将提供给所有新用户。',
          TOOLTIP_REVISIT_FLOW: '使用此切换选择在用户再次访问聊天机器人时提供给用户的聊天流程。',
          TOOLTIP_ACTION: '编辑或删除聊天流程',
        },
        modal: {
          deleteFlow: '删除流程',
          wantToDeleteThisFlow: '您确定要删除此流程吗？',
        },
        noDataFound: {
          flows: '聊天流程',
          noFlowsAddedYet: '尚未添加聊天流程！',
        }
      },
      input: {
        manageTemplates: '管理模板',
        manageYourTemplatesForMarketingAutomation: '管理用于营销自动化的模板',
        syncTemplates: '同步模板',
        createTemplateHeader: '创建模板',
        title: '标题',
        info: '信息',
        category: '类别',
        status: '状态',
        action: '操作',
        shipmentUpdate: '发货更新',
        name: '名称',
        headerOptional: '标题（可选）',
        bodyRequired: '正文（必填）',
        footerOptional: '页脚（可选）',
        buttonsOptional: '按钮（可选）',
        makeUpto3Buttons: '最多创建3个按钮',
        makeUpto2ButtonsToRedirect: '最多创建2个按钮以重定向客户到您的网站',
        placeholders: {
          nameYourTemplate: '为您的模板命名（使用下划线分隔单词）',
          enterText: '输入文本（最多60个字符）',
          enterImageUrl: '输入图像网址',
          enterVideoUrl: '输入视频网址',
          templateMessage: '模板消息',
          smallFooterAtBottom: '底部小页脚',
          buttons: '按钮',
          text: '文本',
          numberWithCountryCode: '带有国家代码的号码',
          enterButtonText: '输入按钮文本（最多20个字符）',
        },
        appTooltip: {
          TOOLTIP_INPUT_TABLE_TITLE: 'WhatsApp模板的标题',
          TOOLTIP_INPUT_TABLE_INFO: '业务发起消息的详细信息',
          TOOLTIP_INPUT_TABLE_CATEGORY: '业务发起消息的类型，如预约、提醒、客户服务消息、发货更新、警报等',
          TOOLTIP_INPUT_TABLE_STATUS: 'WhatsApp模板的状态由WhatsApp拒绝或批准。WhatsApp模板必须首先由WhatsApp批准，这是一项付费服务。',
          TOOLTIP_INPUT_TABLE_ACTIONS: '删除模板',
        },
        noDataFound: {
          templates: '模板',
          noTemplatesCreatedYet: '尚未创建任何模板！',
        },
        modal: {
          deleteTemplate: '删除模板',
          wantToDeleteThisTemplate: '您确定要删除此模板吗？',
        },
        createTemplate: {
          createTemplates: '创建模板',
          createTemplatesForMarketingAutomation: '为营销自动化创建您的模板',
          templateMeta: '模板元数据',
          selectLanguage: '选择语言',
          header: '头部',
          optional: '可选',
          samplesForHeaderContent: '头部内容的示例',
          toHelpMetaReviewYourContent: '为了帮助元素审查您的内容，请提供头部变量或媒体的示例。请勿包含任何客户信息。',
          body: '正文',
          addVariable: '添加变量',
          samplesForBodyContent: '正文内容的示例',
          toHelpUsReviewYourContent: '为了帮助我们审查您的内容，请提供正文中变量的示例。请勿包含任何客户信息。',
          footer: '页脚',
          buttons: '按钮',
          typeOfAction: '操作类型',
          call: '呼叫',
          phone: '电话',
          website: '网站',
          static: '静态',
          urlType: 'URL类型',
          type: '类型',
          customButton: '自定义按钮',
          addAnotherButton: '添加另一个按钮',
          preview: '预览',
          test: '测试',
          create: '创建',
          addSampleUrl: '添加示例URL',
          toHelpMetaReviewYourMessage: '为了帮助元素审查您的消息模板，请添加网站URL的示例。请勿使用真实客户信息。',
          placeholders: {
            enterMessageTemplateName: '输入消息模板名称',
            searchTemplateByName: '按名称搜索模板',
            selectTemplate: '选择模板',
            enterText: '输入文本',
            enterBody: '输入正文',
            enterContentForVariable: '输入变量内容',
            enterFooter: '输入页脚',
            phone: '电话*',
            enterWebsiteUrl: '输入网站网址',
          },
          bpInput: {
            name: '名称',
            buttonText: '按钮文本',
            websiteUrl: '网站网址',
          },
          bpDropDown: {
            selectCategory: '选择类别',
          }
        },
        templatePreview: {
          preview: '预览',
          test: '测试',
        },
        templateConfig: {
          saveChanges: '保存更改',
          discard: '丢弃',
          triggerChatFlowOnTemplateReply: '在模板回复时触发聊天流程',
          templateDetails: '模板详细信息',
          configureFlows: '配置流程',
          selectFlow: '选择流程',
          name: '名称'
        }
      },
      shopManagement: {
        shopManagement: '店铺管理',
        manageECommerceShopFromBotPenguin: '从BotPenguin管理与电子商务店铺连接的店铺',
        comingSoon: '(即将推出)',
        wooCommerce: {
          createConfiguration: '创建配置',
          eventConfiguration: {
            createConfiguration: '创建配置',
            templateHeader: '模板头部',
            selectFile: '选择文件',
            templateMessage: '模板消息',
            saveChanges: '保存更改',
            bpDropDown: {
              selectEvent: '选择事件',
              selectTemplate: '选择模板',
            }
          }
        }
      },
      whatsappProfile: {
        whatsappProfile: 'WhatsApp个人资料',
        manageYourBotProfile: '随时管理您的机器人个人资料。',
        allSetNoActionRequired: '一切设置完毕，无需操作！',
        congratulationsYourAccountIsLive: '恭喜！您的帐户已上线，具有完全访问权限',
        somethingIsWrongReactivateYourBot: '出现问题，请重新激活您的机器人！',
        itSeemsLikeYourBotIsNotWorkingProperly: '似乎您的机器人工作不正常，请重置您的机器人',
        reConfigureYourBot: '重新配置您的机器人',
        phoneNumberDetails: '电话号码详情',
        phoneNumber: '电话号码',
        nA: 'NA',
        phoneNumberId: '电话号码ID',
        wabaId: 'WABA ID',
        change: '更改',
        accessToken: '访问令牌',
        messagingLimit: '消息限制',
        qualityRating: '质量评分',
        whatsappBusinessAccountName: 'WhatsApp业务帐户名称',
        whatsappPublicProfile: 'WhatsApp公共资料',
        profilePicture: '头像',
        aboutText: '关于文本',
        address: '地址',
        description: '描述',
        email: '电子邮件',
        websitePrimary: '网站（主要）',
        websiteSecondary: '网站（次要）',
        businessVertical: '业务垂直',
        editProfile: '编辑个人资料',
        thisIsABusinessAccount: '这是一个商业账户',
        aboutAndPhoneNumber: '关于和电话号码',
        yourTrialAccountIsLive: '恭喜！您的试用帐户已上线，可以在您的已验证号码上全面访问',
        updateWithNewAccessToken: '使用新的访问令牌更新',
      },
      widgets: {
        manageWidgets: '管理小部件',
        widgetsAreRoutingTools: '小部件是增加机器人使用的路由工具',
        needHelp: '需要帮助？',
        wantToMakeChanges: '想要进行更改？',
        prePopulatedMessage: '预填充消息',
        discard: '丢弃',
        updateWidget: '更新小部件',
        hiThere: '你好 ',
        seeHowToUse: '查看如何使用',
        editIcon: '编辑图标',
        editPrePopulatedMessage: '编辑预填充消息',
        small: '小',
        medium: '中',
        large: '大',
        leftMiddle: '左中',
        rightMiddle: '右中',
        leftBottom: '左下',
        rightBottom: '右下',
        chatBotIcon: '聊天机器人图标',
        link: '链接',
        qrcode: 'QR码',
        copyChatBotCode: '复制聊天机器人代码',
        copyWALink: '复制WA链接',
        downloadQrCode: '下载QR码',
        installChatBotIconOnYourWebsite: '在您的网站上安装聊天机器人图标',
        shareWhereEverYouWantRedirectUsersTo: '在任何地方分享并将用户重定向到您的WhatsApp机器人，一键完成',
        copyAndAddInYourWebsiteHeaderFile: '复制并添加到您的网站页眉文件',
        copyLinkAndStartSharing: '复制链接并开始分享！',
        downloadQrCodeAndStartSharing: '下载QR码并开始分享！',
        addCodeAndDeployNewCodeAndDone: '添加代码，部署新代码，完成！',
        wantToLearnHowToUseIt: '想要学习如何使用吗？',
        placeholders: {
          enterWhatsappNumber: '输入WhatsApp号码',
          updateYourMessageHere: '在此更新您的消息...',
        },
        bpDropDown: {
          selectIcons: '选择图标',
          iconSize: '图标大小',
          iconPlacement: '图标放置',
        },
        bpInput: {
          whatsappNumber: 'WhatsApp号码',
        }
      },
      catalog: {
        createCatalog: '创建目录',
        createProductCatalogOnTheMetaCommerceManagerOrLinkItWithShopify: '在Meta Commerce Manager上创建产品目录或将其与Shopify链接',
        useYourMetaCommerceManagertoManageCatalogs: '使用您的Meta commerce manager管理目录',
        connectCatalogToWhatsAppAccount: '将目录连接到WhatsApp账户',
        connectYourCatalogsToWhatsAppAccountUsingYourWhatsAppManager: '使用您的WhatsApp经理将目录连接到WhatsApp账户',
        useYourMetaWhatsAppManagerToConnectCatalogsAndUsethemWithBotPenguin: '使用您的Meta WhatsApp经理连接目录并与BotPenguin一起使用',
        goToMeta: '转到Meta',
        goToShopify: '转到Shopify',
        next: '下一步',
        back: '返回',
        setupCatalog: '设置目录',
        completeAllTheStepsToEnableCatalogMessages: '完成所有步骤以启用目录消息'
      },
      generalSetting: {
        sendInactivityMessage: '用户不活动消息',
        sessionTimeOutInHours: '会话超时',
        enterSessionTimeOutWindowInHours: '输入会话超时窗口时间（小时）',
        sessionTimeOutInHoursTooltip: `输入在聊天会话由于不活动而自动超时之后的持续时间
           。如果用户在会话超时后发送任何消息，Chatflow将重新启动`,
        restartChatFlowTriggers: '重新启动聊天流触发器',
        enterKeyWordsToRestartChatAndhitEnter: '输入关键字以重新启动聊天并按回车键',
        restartChatFlowTriggersTooltip: `在这里指定用户输入并提交时将触发聊天流重新启动的关键字
          。在添加每个关键字后按Enter以添加多个关键字。`,
        liveChatTriggers: '实时聊天触发器',
        enterKeyWordsToTriggerLiveChatAndhitEnter: '输入关键字以触发实时聊天并按回车键',
        liveChatTriggersTooltip: `定义关键字，用户输入并提交时将从自动聊天转换为实时聊天。当用户需要与实时代理交流时，这很有用
          。在添加每个关键字后按Enter以添加多个关键字。`,
        messageAfterAutomatedFlowCompleted: '自动流程完成后的消息',
        enterYourMessage: '输入您的消息',
        messageAfterAutomatedFlowCompletedTooltip: `输入在用户完成自动化聊天流但会话未超时时将显示给用户的消息`,
        restart: '重新启动',
        liveChat: '实时聊天',
        lineOneForDefaultMessage: '如果您有更多问题或需要帮助，下面是您可以采取的措施：',
        to: '到',
        restartTheChat: '重新启动聊天',
        simpleTypeRestartAndHitEnter: `只需键入'Restart'并按Enter键。这将使您返回到我们对话流的开头。`,
        lineThreeForDefaultMessagePartOne: `如果您想与`,
        liveAgent: `实时代理交谈，`,
        lineThreeForDefaultMessageLastPart: `键入'Live Chat'并按Enter键。我们的团队随时为您提供帮助。`,
        saveChanges: '保存更改',
        discard: '丢弃',
        configureBotsGeneralSettings: `配置机器人的常规设置`,
        minutes: '分钟',
        hours: '小时',
      }
    },
    activateWhatsAppBot: {
      justAStepAway: '仅一步之遥',
      seeHowToUse: '查看如何使用',
      testWhatsAppTrialBot: '测试您的WhatsApp试用Chatbot',
      sendMessage: '发送消息',
      sendWhatsAppMessageOn: '在WhatsApp上发送消息至',
      bySavingInYourContact: '通过保存在您的联系人中，并且消息应以以下内容开始',
      connect: '连接',
      or: '或',
      scanQRCode: '扫描QR码',
      yourPhoneWillOpen: '您的手机将打开一个预填充的消息，发送至我们的沙盒号码。在WhatsApp上点击“发送”',
      sendVerificationCode: '发送验证码',
      copyAndEnterCode: '复制并输入6位数代码',
      shareWhereYouWant: '在任何地方分享并通过单击将用户重定向到您的WhatsApp机器人',
      youShouldHaveReceived: '您应该已收到6位数代码',
      EnterYourPhoneNumber: '输入您的电话号码',
      send: '发送',
      sixDigitCode: '输入6位数代码',
      pleaseNote: '请注意：6位数验证码可能需要最多3分钟，请等待再次发送。',
      resendVerificationCode: '重新发送验证码',
      verify: '验证',
      providePhoneNumber: '请提供您要用于测试的号码',
      demoBotisReady: '太棒了！您的演示机器人已准备就绪',
      placeHolder: {
        phone: '输入您的电话号码',
        code: '输入验证码',
      }
    }
  },
  integrations: {
    thirdPartyAppsIntegration: '第三方应用集成',
    thirdPartyApps: '第三方应用',
    customApps: '自定义应用',
    preview: '预览',
    test: '测试',
    install: '安装',
    appTooltip: {
      clickToInstallYourBotToSelectedPlatform: '单击以将您的机器人安装到所选平台',
      TOOLTIP_MY_INTEGRATION_TITLE: '将您自定义创建的应用程序与您的机器人集成',
      TOOLTIP_ALL_INTEGRATION_TITLE: '将您的机器人连接到可用的第三方应用程序/CRM',
    },
    allIntegration: {
      list: {
        thirdPartyAppsIntegrations: '第三方应用集成',
        integrateYourBotWithListedCrms: '将您的机器人与列出的应用程序/CRM集成。',
        help: '帮助',
        name: '名称',
        status: '状态',
        action: '操作',
        chatGpt: 'ChatGPT',
        addOn: '附加组件',
        purchased: '已购买',
        readyToRideGptWave: '准备好迎接GPT浪潮了吗？立即集成。',
        purchase: '购买',
        notConnected: '未连接',
        integrated: '已集成',
        configure: '配置',
        connected: '已连接',
        edit: '编辑',
        connect: '连接',
        requestYourIntegration: '请求您的集成',
        toRequestNewIntegration: '要请求新的集成，请输入以下详细信息，然后我们将与您联系。',
        emailId: '电子邮件ID',
        integrationName: '集成名称',
        contactNumber: '联系号码',
        howSoonYouWantToAddThisIntegration: '您希望多快将此集成添加到',
        sendRequest: '发送请求',
        cancel: '取消',
        requestSent: '请求已发送！',
        yourRequestSuccessfullySent: '您的新集成请求已成功发送。',
        goBack: '返回',
        disconnect: '断开连接',
        OopsIntegrationAreNotAvailable: '糟糕！在',
        pleaseUpgradeTo: '请升级到',
        planForIntegration: '进行集成。',
        placeholders: {
          searchIntegrationByName: '按名称搜索集成',
          enterTeamMemberName: '输入团队成员姓名',
          enterEmailId: '输入电子邮件ID',
          enterIntegrationName: '输入集成名称',
          searchCountry: '搜索国家',
          enterContactNumber: '输入联系号码',
          addComment: '添加评论',
        },
        noDataFound: {
          integrations: '集成',
          noIntegrationsFound: '找不到集成！',
        },
        appTooltip: {
          nameOfAppOrCrm: '应用程序/CRM的名称',
          statusAsConnectedOrNotConnected: '连接/未连接的状态',
          clickToConnectToAppOrCrm: '单击连接到应用程序/CRM',
        },
        feedbackModal: {
          submit: '提交',
        }
        },
        providers: {
          pabbly: {
            newLeadHooks: '新线索挂钩',
            newMessageHooks: '新消息挂钩',
            addParameters: '',
            update: '更新',
            connect: '连接',
            botId: '机器人ID',
            toolTip: {
              copyBotId: `检索您的机器人ID，以便无缝集成Pabbly与${brand}以自动执行Pabbly上的操作`
            },
            placeholders: {
              enterYourPabblyWebhookUrl: '输入您的Pabbly Webhook URL',
            }
          },
          agileCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            agileCrmDomain: 'Agile CRM域',
            nameIsRequired: '名称是必需的',
            emailAddress: '电子邮件地址',
            apiToken: 'API令牌',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameter: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              exampleSite: 'https://company.agilecrm.com',
              exampleEmail: 'example@company.extention',
              enterTokenHere: '在此输入令牌',
            }
          },
          appTivo: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            accessKey: '访问密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiKeyHere: '在此输入API密钥',
              enterAccessKeyHere: '在此输入访问密钥',
            }
          },
          autoPilot: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            nameIsRequired: '名称是必需的',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiToken: '输入API令牌',
            }
          },
          bitrixCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            nameColon: '名称：',
            inboundWebhookUrl: '入站Webhook网址',
            nameIsRequired: '名称是必需的',
            leadTitle: '线索标题',
            source: '来源',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterInboundWebhookUrl: '输入入站Webhook网址...',
              enterTitle: '输入标题',
              enterSource: '输入来源'
            }
          },
          calendarHeroCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            connect: '连接',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterTokenHere: '在此输入令牌',
            }
          },
          capsuleCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            nameIsRequired: '名称是必需的',
            testLead: '测试线索',
            connect: '连接',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiToken: '输入API令牌',
            }
          },
          chakraCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            testLead: '测试线索',
            connect: '连接',
            selectTheQuestion: '选择要将用户回复作为值发送的问题',
            mapWith: '映射到',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiToken: '输入API令牌',
              attributes: '属性（键）',
              values: '值',
            }
          },
          chatGpt: {
            chatGptApiKey: 'ChatGPT (Open AI) API密钥',
            chatGpt: 'ChatGPT (Open AI)',
            gpt3: 'GPT-3.5（更低成本，平均准确度）',
            gpt4: 'GPT-4（更高成本，更高准确度）',
            gptAssistant: '助手Beta*（高级成本，更高准确度）',
            readyToRideWave: '准备好乘坐GPT浪潮了吗？现在集成。',
            doNotHaveAnyApiKeyNeedHelp: '没有API密钥，需要帮助吗？',
            authenticate: '认证',
            nowYouCanAccessChatGpt: '现在您可以在聊天流构建器中访问Chat GPT组件',
            paymentSuccessful: '付款成功！',
            paymentHasBeenCompletedSuccessfully: '付款已成功完成。您已准备好培训您的机器人',
            cancel: '取消',
            trainNow: '现在培训',
            paymentInProgress: '付款进行中...',
            apiKey: 'ChatGPT API密钥',
            model: '模型',
            integrateWithChatGPT: '与ChatGPT集成',
            updateKey: '更新密钥',
            connect: '连接',
            update: '更新',
            disconnect: '断开连接',
            placeholders: {
              chatGptApiKey: 'ChatGPT (Open AI) API密钥',
            }
          },
          closeCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            connect: '连接',
            testLead: '测试线索',
            leadId: '线索ID',
            selectLeadId: '选择线索ID',
            questionColon: '问题：',
            addParameters: '添加参数',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterTokenHere: '在此输入令牌',
            }
          },
          copperCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            emailAddress: '电子邮件地址',
            leadTitle: '线索标题',
            apiToken: 'API令牌',
            nameIsRequired: '名称是必需的',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              exampleEmail: 'example@company.extention',
              enterYourLeadTitle: '输入您的线索标题',
              enterTokenHere: '在此输入令牌',
            }
          },
          dripCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            dripCrmAccountId: 'Drip CRM账户ID',
            apiToken: 'API令牌',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterAccountIdHere: '在此输入账户ID',
              enterYourTokenHere: '在此输入令牌',
            }
          },
          elevioCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apikey: 'API密钥',
            accessToken: '访问令牌',
            connect: '连接',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            selectParameter: '选择参数',
            disconnect: '断开连接',
            update: '更新',
            save: '保存',
            placeholders: {
              enterApiKeyHere: '在此输入API密钥',
              enterTokenHere: '在此输入令牌',
            }
          },
          engageBay: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            nameIsRequired: '名称是必需的',
            connect: '连接',
            questionColon: '问题：',
            testLead: '测试线索',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiToken: '输入API令牌',
            }
          },
          extraEdge: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            authToken: 'AuthToken',
            source: '来源',
            connect: '连接',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterAuthTokenHere: '在此输入AuthToken',
              enterSourceHere: '在此输入来源',
            }
          },
          facebookPixel: {
            facebookPixel: 'Facebook像素',
            getInsight: '通过BotPenguin的Google Analytics集成获取将您的业务转变为企业的见解',
            pixelId: 'Facebook像素ID',
            connect: '连接',
            disconnect: '断开连接',
            placeholders: {
              enterYourId: '输入Facebook像素ID',
            }
          },
          firmao: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            companyName: '公司名称',
            emailAddress: '电子邮件地址',
            password: '密码',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapsWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterCompanyName: '输入公司名称',
              enterEmailAddress: '输入电子邮件地址',
              enterPassword: '输入密码',
            }
          },
          firstPromoterCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiKeyHere: '在此输入API密钥',
            }
          },
          flowlu: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            flowluDomain: 'Flowlu域',
            apiToken: 'API令牌',
            title: '标题',
            connect: '连接',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              exampleDomain: 'https://yourcompany.flowlu.com',
              enterTokenHere: '在此输入令牌',
              enterYourLeadTitle: '输入您的线索标题',
            }
          },
          freshdeskCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            freshdeskDomain: 'Freshdesk域',
            apiToken: 'API令牌',
            nameIsRequired: '名称是必需的',
            connect: '连接',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              exampleDomain: 'https://yoursubdomain.freshdesk.com',
              enterTokenHere: '在此输入令牌',
            }
          },
          freshworksCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            freshworkCrmDomain: 'Freshwork CRM域',
            apiToken: 'API令牌',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              exampleDomain: 'https://yourcompany.myfreshworks.com',
              enterToken: '在此输入令牌',
            }
          },
          frontApp: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            mapWith: '映射到',
            select: '选择',
            update: '更新',
            disconnect: '断开连接',
            placeholders: {
              enterApiToken: '输入API令牌',
            }
          },
          getResponseCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            connect: '连接',
            testLead: '测试线索',
            campaignList: '活动列表',
            selectCampaign: '选择活动',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterTokenHere: '在此输入令牌',
            }
          },
          googleAnalytics: {
            googleAnalytics: 'Google Analytics',
            getInsights: '通过BotPenguin的Google Analytics集成获取将您的业务转变为企业的见解',
            measurementId: '测量ID',
            connect: '连接',
            disconnect: '断开连接',
            placeholders: {
              enterYourId: '输入您的ID',
            }
          },
          googleCalendar: {
            testLead: '测试线索',
            name: '名称：',
            email: '电子邮件：',
            appointmentSummary: '约会摘要',
            appointmentDescription: '约会描述',
            addParameters: '添加参数',
            questionColon: '问题：',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            pause: '暂停',
            resume: '继续',
            disconnect: '断开连接',
            reconnect: '重新连接',
          },
          googleContacts: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            name: '名称：',
            email: '电子邮件：',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
          },
          googleRedirect: {

          },
          googleSheet: {
            testLead: '测试线索',
            title: '标题',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            update: '更新',
            save: '保存',
            pause: '暂停',
            resume: '继续',
            disconnect: '断开连接',
            reconnect: '重新连接',
            placeholders: {
              mappingValues: '映射值',
            }
          },
          googleTask: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            name: '名称：',
            email: '电子邮件：',
            taskList: '任务列表',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            pause: '暂停',
            resume: '继续',
            disconnect: '断开连接',
            reconnect: '重新连接',
          },
          grooveHq: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            select: '选择',
            addParameters: '添加参数',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterTokenHere: '在此输入令牌',
            }
          },
          helpCrunchCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            connect: '连接',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiHere: '在此输入API',
            }
          },
          helpDeskCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            testLead: '测试线索',
            accountId: '账户ID',
            accessToken: '访问令牌',
            connect: '连接',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterAccountIdHere: '在此输入账户ID',
              enterAccessTokenHere: '在此输入访问令牌',
            }
          },
          helpDocsCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API密钥',
            connect: '连接',
            questionColon: '问题：',
            testLead: '测试线索',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterTokenHere: '在此输入令牌',
            }
          },
          helpLink: {
            help: '帮助',
          },
          helpRaceCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            helpRaceCrmDomain: 'Helprace CRM域',
            emailAddress: '电子邮件地址',
            apiToken: 'API令牌',
            connect: '连接',
            update: '更新',
            placeholders: {
              exampleDomain: 'https://company.helprace.com',
              exampleEmail: 'example@company.extension',
              token: '令牌',
            }
          },
          helpShiftCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            domainName: '域名',
            apiKey: 'API密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterTokenHere: '在此输入令牌',
            }
          },
          hubspotCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            nameIsRequired: '名称是必需的',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            selectTheQuestion: '选择用户回复作为值的问题',
            placeholders: {
              enterApiToken: '输入API令牌',
              values: '值'
            }
          },
          infobipCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiHere: '在此输入API',
            }
          },
          insightlyCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API密钥',
            nameIsRequired: '名称是必需的',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiToken: '输入API令牌',
            }
          },
          jiraCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            emailAddress: '电子邮件地址',
            apiUrl: 'API网址',
            connect: '连接',
            testLead: '测试线索',
            selectProjectName: '选择项目名称',
            selectIssueType: '选择问题类型',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapsWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterTokenHere: '在此输入令牌',
              enterEmailAddress: '输入电子邮件地址',
              exampleUrl: 'https://example.atlassian.net',
            }
          },
          jogetCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiUrl: 'API网址',
            nameIsRequired: '名称是必需的',
            apiKey: 'API密钥',
            apiId: 'API ID',
            connect: '连接',
            testLead: '测试线索',
            mapWith: '映射到',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            selectTheQuestion: '选择用户回复作为值的问题',
            placeholders: {
              enterApiUrl: '输入API网址',
              enterApiKey: '输入API密钥',
              enterApiId: '输入API ID',
              attributes: '属性（键）',
              values: '值',
            }
          },
          karmaCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterTokenHere: '在此输入令牌',
            }
          },
          kylasCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            nameIsRequired: '名称是必需的',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiToken: '输入API令牌',
            }
          },
          leadSquared: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            accessKey: '访问密钥',
            secretKey: '秘密密钥',
            connect: '连接',
            apiLogs: 'API日志',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            udpate: '更新',
            save: '保存',
            disconnect: '断开连接',
            filterApplied: '已应用筛选',
            retry: '重试',
            back: '返回',
            filterYourLeads: '筛选您的线索',
            filterOn: '筛选',
            filterBy: '筛选',
            discard: '丢弃',
            applyFilter: '应用筛选',
            loadMore: '加载更多',
            placeholders: {
              enterAccessKeyHere: '在此输入访问密钥',
              enterSecretKeyHere: '在此输入秘密密钥',
              attributes: '属性（键）',
              values: '值',
            },
            appTooltip: {
              filterDataBasedOnResponse: '根据响应筛选数据',
            }
          },
          liveAgentCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            apiUrl: 'API网址',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiHere: '在此输入API',
              exampleUrl: 'https://comapanyName.ladesk.com'
            }
          },
          microsoftTeams: {
            downloadPackage: '下载 Microsoft Teams 应用程序包',
            downloadApp: '下载应用',
            wantToLearnHowToUploadIt: '想了解如何上传吗？',
            needHelp: '需要帮助吗？',
          },
          moengageUser: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiUrl: 'API网址',
            appId: 'APP ID',
            nameIsRequired: '需要App ID',
            dataApiKey: '数据 API 密钥',
            dataApiKeyIsRequired: '需要数据 API 密钥',
            connect: '连接',
            testLead: '测试线索',
            addParameters: '添加参数',
            mapWith: '映射到',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            selectTheQuestion: '选择要将用户回复作为值发送的问题',
            placeholders: {
              enterApiUrl: '输入 API 网址',
              enterAppId: '输入 APP ID',
              enterDataApiKey: '输入数据 API 密钥',
              attributes: '属性（键）',
              pressForMappingQuestion: '按 / 键进行映射问题',
            }
          },
          nethuntCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            emailAddress: '电子邮件地址',
            apiKey: 'API密钥',
            connect: '连接',
            testLead: '测试线索',
            leadId: '线索ID',
            selectLeadId: '选择线索ID',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterEmailHere: '在此输入电子邮件',
              enterApiKeyHere: '在此输入API密钥',
            }
          },
          nimbleCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiToken: '输入API令牌',
            }
          },
          noCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            noCrmDomain: 'Nocrm域',
            leadTitle: '线索标题',
            titleIsRequired: '需要标题',
            token: '令牌',
            tokenIsRequired: '需要令牌',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              exampleDomain: 'https://YOUR_SUBDOMAIN_HERE.nocrm.io',
              enterYourLeadTitle: '输入线索标题',
              enterYourToken: '输入令牌',
            }
          },
          nutshellCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            emailAddress: '电子邮件地址',
            apiKey: 'API密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiToken: '输入API令牌',
            }
          },
          onpipelineCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            secretToken: '密钥令牌',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterTokenHere: '在此输入令牌',
            }
          },
          ontraportCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            appId: '应用程序ID',
            appIdIsRequired: '应用程序ID是必需的',
            apiKey: 'API密钥',
            apiKeyIsRequired: 'API密钥是必需的',
            connect: '连接',
            update: '更新',
            disconnect: '断开连接',
            placeholders: {
              appId: '应用程序ID',
              apiKey: 'API密钥',
            }
          },
          outlook: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            clientId: '客户端ID',
            connect: '连接',
            clientSecret: '客户端密钥',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            save: '保存',
            update: '更新',
            disconnect: '断开连接',
            placeholders: {
              enterClientIdHere: '在此输入客户端ID',
              enterClientSecretHere: '在此输入客户端密钥',
            }
          },
          pipedriverCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            pipedriverDomain: 'Pipedriver域',
            domainIsRequired: '域是必需的',
            apiToken: 'API令牌',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              exampleDomain: 'https://yourcompany.pipedrive.com',
              enterTokenHere: '在此输入令牌',
            }
          },
          pipeline: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            apiKeyIsRequired: 'API密钥是必需的',
            appKey: '应用密钥',
            appKeyIsRequired: '应用密钥是必需的',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiKey: '输入API密钥',
              enterAppKey: '输入应用密钥',
            }
          },
          plivoSmsBot: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            authId: '身份验证ID',
            authToken: '身份验证令牌',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterTokenHere: '在此输入令牌',
            }
          },
          recurlyCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiHere: '输入API',
            }
          },
          salesfareCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiKey: '输入API密钥',
            }
          },
          salesforce: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            domain: '域',
            clientId: '客户端ID',
            clientSecret: '客户端密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterDomainHere: '在此输入域',
              enterClientIdHere: '在此输入客户端ID',
              enterClientSecretHere: '在此输入客户端密钥',
            }
          },
          sendInBlueCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            addEventsAndTemplates: '添加事件和模板：',
            add: '添加',
            question: '问题',
            reply: '回复',
            requestBody: '请求主体',
            validateJson: '验证JSON',
            emailAddress: '电子邮件地址',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            selectTheQuestion: '选择用户回复作为值的问题',
            placeholders: {
              enterApiHere: '在此输入API',
              enterTemplateId: '输入模板ID',
              typeYourJsonCodeHere: '在此输入您的JSON代码',
            },
            appTooltip: {
              typeYourJsonCode: '输入您的JSON代码',
              clickToValidateJsonCode: '单击验证JSON代码',
            }
          },
          shipwayCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            userName: '用户名',
            licenseKey: '许可证密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterNameHere: '在此输入名称',
              enterKeyHere: '在此输入密钥',
            }
          },
          supportBeeCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterTokenHere: '在此输入令牌',
            }
          },
          simplybook: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            company: '公司',
            loginId: '登录ID',
            password: '密码',
            testLead: '测试线索',
            connect: '连接',
            selectTheQuestion: '选择要将用户回复作为值发送的问题',
            mapWith: '映射到',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            selectParameter: '选择参数',
            placeholders: {
              enterCompanyHere: '在此输入公司名称',
              enterLoginIdHere: '在此输入登录ID',
              enterPasswordHere: '在此输入密码',
              values: '值',
            }
          },
          twilio: {
            description: '使用 Twilio 随时为客户进行清晰的语音通话。',
            accountSid: '账户SID',
            phoneNumber: '电话号码',
            twiMlSid: 'TwiML App SID',
            apiKey: 'API密钥 ',
            apiSecret: 'API密钥 ',
            apiUrl: '应用程序网址（POST）',
            required: '必填',
            accountSidRequired: '账户SID为 ',
            phoneNumberRequired: '电话号码为 ',
            sidRequired: 'TwiML App SID为 ',
            apiKeyRequired: 'API密钥为 ',
            apiSecretRequired: 'API密钥为 ',
            update: '更新',
            connect: '连接',
            disconnect: '断开连接',
          },
          teamGate: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            applicationKey: '应用密钥',
            authToken: '身份验证令牌',
            connect: '连接',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApplicationKeyHere: '在此输入应用密钥',
              enterTokenHere: '在此输入令牌',
            }
          },
          wealthboxCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            accessToken: '访问令牌',
            connect: '连接',
            testLead: '测试线索',
            question: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterTokenHere: '在此输入令牌',
            }
          },
          webhopersCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            webhoperDomain: 'Webhoper域',
            domainIsRequired: '需要域',
            companyName: '公司名称',
            companyIsRequired: '需要公司',
            leadSource: '线索来源',
            leadSourceIsRequired: '需要线索来源',
            division: '部门',
            divisionIsRequired: '需要部门',
            enterPassword: '输入密码',
            passwordIsRequired: '需要密码',
            disconnect: '断开连接',
            update: '更新',
            connect: '连接',
            placeholders: {
              exampleDomain: 'http://yourcompanydomain',
              enterYourCompanyName: '输入公司名称',
              enterLeadSource: '输入线索来源',
              enterDivision: '输入部门',
              enterPassword: '输入密码',
            }
          },
          zapierCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            name: '名称：',
            zapier: 'Zapier',
            inboundWebhookUrl: '入站 Webhook 网址',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterWebhookUrl: '输入 Webhook 网址',
            }
          },
          zendeskCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            emailAddress: '电子邮件地址',
            apiUrl: 'API网址',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterEmailAddress: '输入电子邮件地址',
              enterUrlHere: '在此输入网址',
              enterTokenHere: '在此输入令牌',
            }
          },
          zingtreeCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiKey: 'API密钥',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiHere: '在此输入API',
            }
          },
          zohoCrm: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            connect: '连接',
            update: '更新',
            disconnect: '断开连接',
            companyName: '公司名称',
            emailAddress: '电子邮件地址',
            phone: '电话',
            countryCode: '国家代码',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            save: '保存',
            testLead: '测试线索',
            crmExtensionUrl: 'CRM扩展URL',
            installExtension: '安装扩展',
            toolTip: {
              crmExtensionUrl: '运行此URL以添加Zoho扩展并从Zoho CRM向WhatsApp发送消息。'
            }
          },
          zohoDesk: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            connect: '连接',
            disconnect: '断开连接',
            testLead: '测试线索',
            emailAddress: '电子邮件地址',
            selectOrganizationName: '选择组织名称',
            selectDepartmentName: '选择部门名称',
            addParameters: '添加参数',
            questionColon: '问题：',
            select: '选择',
            mapsWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
          },
          zohoProject: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            testLead: '测试线索',
            connect: '连接',
            disconnect: '断开连接',
            projectsList: '项目列表',
            selectProjectsName: '选择项目名称',
            projectsTaskList: '项目任务列表',
            selectTaskListName: '选择任务列表名称',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
          },
          wooCommerce: {
            configure: '配置',
            automatedMessage: '自动消息',
            configureTab: {
              wooCommercePluginApiKey: 'WooCommerce插件API密钥',
              downloadWooCommercePlugin: '下载WooCommerce插件'
            },
            automatedMessageTab: {
              abandonedRecoveryMessage: '放弃恢复消息',
              configureAutomatedRecoveryMessagesToWinBackCustomerWhoAbandonedTheirCarts: '配置自动恢复消息，以挽回放弃购物车的客户',
              enableAbandonedCartRecoveryMessaegs: '启用放弃购物车恢复消息',
              selectTemplate: '选择模板',
              sendMessageAfter: '发送消息后',
              templateMessage: '模板消息',
              saveChanges: '保存更改',
              selectFile: '选择文件',
              orderCompleted: '订单完成',
              templateHeader: '模板标题',
              orderFulfillMent: '订单履行',
              enableOrderConfirmationMessages: '启用订单确认消息',
              sendAnOrderConfirmationMessageAsSoonAsACustomerPlacesAnOrder: '顾客下订单后立即发送订单确认消息。',
              orderShipmentMessageIsSentWhenYouFulfillAnOrder: '履行订单时发送订单发货消息。',
              enableOrderFulfillmentMessages: '启用订单履行消息',
              returnExchangeRequest: '退换货请求',
              theMessageIsSentAfterARefundIsRequested: '在请求退款后发送消息',
              enableOrderRefundMessages: '启用订单退款消息',
            }
          },
          shopify: {
            configure: '配置',
            automatedMessage: '自动消息',
            configureTab: {
              enterYourShopifyDomain: '输入您的Shopify域',
              disconnect: '断开连接',
              integrated: '已集成',
              install: '安装',
            },
            automatedMessageTab: {
              shopifyAutomatedMessage: 'Shopify自动消息',
              viewYourCashOnDeliveryInsights: '查看您的货到付款见解。',
              noTemplateFound: '未找到模板',
              hours: '小时',
              minutes: '分钟',
              saveChanges: '保存更改',
              selectTemplate: '选择模板',
              templateMessage: '模板消息',
              selectFile: '选择文件',
              templateHeader: '模板标题',
              sendMessageAfter: '发送消息后',
              select: '选择',
              abandonedCartRecovery: '遗弃购物车恢复',
              abandonedCartDescription: '通过WhatsApp聊天通知用户关于遗弃的购物车以便跟进。',
              enableAbandonedCartRecoveryMessages: '启用遗弃购物车恢复消息',
              orderCreated: '订单已创建',
              orderCreatedDescription: '为用户的新订单即时发送提醒。',
              enableOrderCreatedMessages: '启用订单已创建消息',
              codOrderTracking: '货到付款订单追踪',
              codOrderTrackingDescription: '在WhatsApp聊天中提供追踪链接，让用户实时追踪货到付款订单。',
              enableCodOrderTrackingMessages: '启用货到付款订单追踪消息',
              orderFulfilled: '订单已履行',
              orderFulfilledDescription: '在成功履行订单时向您的客户发送通知。',
              enableOrderFulfilledMessages: '启用订单已履行消息',
              orderCancelled: '订单已取消',
              orderCancelledDescription: '在WhatsApp上高效显示、管理和确认取消的订单。',
              enableOrderCancelledMessages: '启用订单已取消消息',
              orderReturnRequestPlaced: '订单退货请求已提交',
              orderReturnRequestPlacedDescription: '当客户在您的Shopify商店提交退货请求时通知他们。',
              enableOrderReturnRequestPlacedMessages: '启用订单退货请求已提交消息',
              orderReturned: '订单已退还（已退款）',
              orderReturnedDescription: '在客户的退货订单履行时向他们发送更新。',
              enableOrderRefundMessages: '启用订单退款消息',
          }
          },
          goHighLevel: {
            youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
            apiToken: 'API令牌',
            nameIsRequired: '名称为必填项',
            connect: '连接',
            testLead: '测试线索',
            questionColon: '问题：',
            addParameters: '添加参数',
            select: '选择',
            mapWith: '映射到',
            selectParameter: '选择参数',
            update: '更新',
            save: '保存',
            disconnect: '断开连接',
            placeholders: {
              enterApiToken: '输入API令牌',
            }
          }
      }
    },
    createIntegration: {
      createNewIntegration: '创建新集成',
      youDoNotHaveAnyIntegrationSetupAsOfNow: '您目前没有任何集成设置。',
      pleaseCreateOneToIntegrateYourFavourite: '请创建一个以集成您喜爱的应用',
      appsWith: '应用与',
      integrationName: '集成名称',
      integrationNameIsRequired: '集成名称是必填的',
      continue: '继续',
      addAnImageToRepresentYourIntegration: '添加图像以代表您的集成。',
      description: '描述',
      submit: '提交',
      youHaveSuccessfullyCreatedIntegration: '您已成功创建集成。现在，您可以进行配置。',
      apiUrl: 'API URL',
      pleaseEnterAValidApiUrl: '请输入有效的API URL',
      requestMethod: '请求方法',
      get: '获取',
      post: '提交',
      put: '放置',
      patch: '修补',
      queryParameter: '查询参数',
      addParameter: '添加参数',
      mapsWith: '映射到',
      question: '问题',
      addQuestion: '添加问题',
      select: '选择',
      selectParameter: '选择参数',
      header: '头部',
      addHeader: '添加头部',
      value: '值',
      connect: '连接',
      requestBody: '请求正文',
      validate: '验证',
      key: '键',
    },
    myIntegrations: {
      integrationDetails: {
        canAlsoBeIntegratedWith: '也可以与此免费CRM集成。',
        apiUrl: 'API URL',
        pleaseEnterAValidApiUrl: '请输入有效的API URL',
        requestMethod: '请求方法:',
        get: '获取',
        post: '发布',
        put: '放置',
        patch: '补丁',
        queryParameter: '查询参数',
        addParameter: '添加参数',
        header: '头部',
        addHeader: '添加标题',
        requestBody: '请求体',
        validateJson: '验证JSON',
        connect: '连接',
        update: '更新',
        delete: '删除',
        selectTheQuestion: '选择您想要将用户回复作为值发送的问题',
        appTooltip: {
          typeYourJsonCode: '输入您的JSON代码',
          clickToValidateJsonCode: '点击验证JSON代码',
        }
      },
      list: {
        customAppsIntegrations: '自定义应用集成',
        integrateYourAppsWith: '将您的应用与集成',
        help: '帮助',
        addIntegration: '添加集成',
        name: '名称',
        status: '状态',
        action: '操作',
        insatlled: '已安装',
        edit: '编辑',
        connect: '连接',
        requestYourIntegration: '请求您的集成',
        toRequestNewIntegration: '要请求新的集成，请输入以下详细信息，然后我们将与您联系。',
        // name: '名称'
        emailId: '电子邮件地址',
        integrationName: '集成名称',
        contactNumber: '联系号码',
        howSoonYouWantToAddThisIntegration: '您希望多快添加此集成',
        sendRequest: '发送请求',
        cancel: '取消',
        delete: '删除',
        oopsOwnIntegrationsAreSupportedOnlyIn: '糟糕！仅支持在',
        plan: '计划',
        pleaseUpgradeTo: '请升级到',
        toCreateOwnIntegrations: '创建自己的集成',
        appTooltip: {
          integrations: '集成',
          noIntegrationsFound: '未找到集成！',
          nameOfYourApp: '您的应用名称',
          clickToConnectApp: '单击以连接应用',
          statusAsConnectedOrNotConnected: '连接状态/未连接状态',
        }
      }
    }

  }
};
